<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">

            <!-- 导出 loading 由全局 exportLoadingMixin（$loading）统一负责，勿再叠自定义遮罩。最后更新：2026-11-02 -->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="tbl-scroll-host">
            <el-table :data="organizations" v-loading="listLoading" row-key="Id" :tree-props="{ children: 'Children' }"
                :row-class-name="orgTableRowClass" style="width: 100%; margin-top: 20px;"
                class="custom-tbl org-tree-tbl" @select="dialogCheck" @row-click="selectCurrentRow" ref="table" height="100%">

                <el-table-column type="selection" width=""></el-table-column>
                <el-table-column prop="Name" label="组织名称" width="" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span :class="scope.row.Level === 2 ? 'org-name-child' : 'org-name-root'">{{ scope.row.Name
                        }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="DepartmentName" label="所属部门" width="" show-overflow-tooltip></el-table-column> -->
                <!-- 校区 + 短标识合并；表头与内容统一左对齐。最后更新：2026-10-28 -->
                <el-table-column label="校区 / 短标识" min-width="200" align="left" header-align="left"
                    class-name="org-campus-short-col" label-class-name="org-campus-short-col">
                    <template slot-scope="scope">
                        <div class="org-campus-short-cell">
                            <span class="org-campus-short-label">校区</span>
                            <div class="org-campus-short-value">
                                <el-tag v-if="scope.row.CampusName" size="mini" type="primary" effect="plain">{{ scope.row.CampusName }}</el-tag>
                                <el-tag v-else-if="getCampusName(scope.row.CampusId) && getCampusName(scope.row.CampusId) !== '-'" size="mini" type="primary" effect="plain">{{ getCampusName(scope.row.CampusId) }}</el-tag>
                                <el-tag v-else size="mini" type="info" effect="plain">未关联校区</el-tag>
                            </div>
                            <span class="org-campus-short-label">标识</span>
                            <div class="org-campus-short-value">
                                <span v-if="scope.row.ShortTag" class="org-short-tag">{{ scope.row.ShortTag }}</span>
                                <span v-else class="admin-empty">—</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Description" label="描述" width="" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AdminNames" label="管理员" min-width="140">
                    <template slot-scope="scope">
                        <el-button
                            v-if="getAdminNamesList(scope.row.AdminNames).length"
                            type="text"
                            size="small"
                            :icon="getAdminNamesList(scope.row.AdminNames).length > 1 ? 'el-icon-user' : ''"
                            class="kq-dept-link-btn"
                            @click.stop="openAdminViewDialog(scope.row)">
                            {{ formatAdminListCellText(scope.row.AdminNames) }}
                        </el-button>
                        <span v-else class="admin-empty">—</span>
                    </template>
                </el-table-column>
                <el-table-column label="成员" min-width="130">
                    <template slot-scope="scope">
                        <el-button
                            v-if="getMemberCount(scope.row) > 0"
                            type="text"
                            size="small"
                            icon="el-icon-user"
                            class="kq-dept-link-btn"
                            @click.stop="showMemberDialog(scope.row)">
                            已纳 {{ getMemberCount(scope.row) }} 名成员
                        </el-button>
                        <span v-else class="admin-empty">—</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ formatDateOnly(scope.row.CreateTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">
                        <div class="table-op-pair">
                            <el-button v-if="scope.row.Level < 2" type="text" class="table-op-link" size="small"
                                @click.stop="handleOpCommand('addSub', scope.row)">添加子组织</el-button>
                            <el-button type="text" class="table-op-link" size="small"
                                @click.stop="handleOpCommand('events', scope.row)">活动事件</el-button>
                            <el-button type="text" class="table-op-link" size="small"
                                @click.stop="handleOpCommand('edit', scope.row)">编辑</el-button>
                            <el-button type="text" class="table-op-link table-op-link--danger" size="small"
                                @click.stop="handleOpCommand('delete', scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <div class="pagination-container">
                <el-pagination layout="total, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="page" :page-size="PageSize" :total="total"
                    style="float: right"></el-pagination>
            </div>

            <el-dialog
                title="校区社团活动总览权限"
                :visible.sync="eventOverviewPermissionDialogVisible"
                width="760px"
                custom-class="overview-permission-dialog"
                :close-on-click-modal="false"
                append-to-body>
                <div class="overview-permission-body">
                    <div class="overview-campus-bar">
                        <div class="overview-campus-label">
                            <i class="el-icon-office-building"></i>
                            <span>配置校区</span>
                        </div>
                        <el-select
                            v-model="eventOverviewPermissionForm.CampusId"
                            filterable
                            size="small"
                            placeholder="请选择校区"
                            class="overview-campus-select"
                            @change="handleOverviewCampusChange">
                            <el-option
                                v-for="item in campusOptions"
                                :key="'overview-campus-' + item.Id"
                                :label="item.Name"
                                :value="item.Id">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="overview-rule-bar">
                        <span class="overview-rule-chip">管理 ⊇ 维护 ⊇ 查看</span>
                        <span class="overview-rule-text">维护自动包含查看，管理自动包含维护；保存时会自动补齐层级关系。</span>
                    </div>

                    <div class="overview-role-list">
                        <div
                            v-for="role in overviewPermissionRoles"
                            :key="role.key"
                            class="overview-role-card"
                            :class="'overview-role-card--' + role.key">
                            <div class="overview-role-head">
                                <div class="overview-role-title-wrap">
                                    <span class="overview-role-icon" :class="'overview-role-icon--' + role.key">
                                        <i :class="role.icon"></i>
                                    </span>
                                    <div>
                                        <div class="overview-role-title">{{ role.title }}</div>
                                        <div class="overview-role-desc">{{ role.desc }}</div>
                                    </div>
                                </div>
                                <div class="overview-role-actions">
                                    <span class="overview-role-count">已选 {{ role.items.length }} 人</span>
                                    <el-button
                                        size="small"
                                        type="primary"
                                        plain
                                        icon="el-icon-user"
                                        :disabled="!eventOverviewPermissionForm.CampusId"
                                        @click="openOverviewTeacherPicker(role.key)">选择教师</el-button>
                                    <el-button
                                        v-if="role.items.length"
                                        size="small"
                                        type="text"
                                        @click="clearOverviewTeachers(role.key)">清空</el-button>
                                </div>
                            </div>
                            <div v-if="role.items.length" class="overview-role-tags">
                                <el-tag
                                    v-for="item in role.items"
                                    :key="role.key + '-' + item.id"
                                    size="small"
                                    type="info"
                                    effect="plain"
                                    closable
                                    disable-transitions
                                    @close="removeOverviewTeacher(role.key, item.id)">
                                    {{ item.name || item.id }}
                                </el-tag>
                            </div>
                            <div v-else class="overview-role-empty">暂未选择教师，点击右侧「选择教师」从内部通讯录添加</div>
                        </div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer overview-permission-footer">
                    <span v-if="overviewPermissionDirty" class="overview-unsaved-tip">人员已修改，保存后生效</span>
                    <div class="overview-permission-footer-actions">
                        <el-button size="small" @click="eventOverviewPermissionDialogVisible = false">取消</el-button>
                        <el-button type="primary" size="small" :loading="eventOverviewPermissionSaving"
                            :disabled="!eventOverviewPermissionForm.CampusId"
                            @click="saveEventOverviewPermissions">保存配置</el-button>
                    </div>
                </span>
            </el-dialog>
            <person-scope-multi-picker-dialog
                :visible.sync="overviewTeacherPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="DepartmentId"
                title="选择总览权限教师"
                :value="overviewPickerItems"
                @confirm="onOverviewTeachersPicked"
            />

            <!-- 编辑对话框 -->
            <el-dialog :title="dialogTitle" :visible.sync="editFormVisible" width="50%" :close-on-click-modal="false">
                <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="110px">

                    <el-form-item label="组织名称" prop="Name">
                        <el-input v-model="editForm.Name"></el-input>
                    </el-form-item>
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" :placeholder="isAddSub ? '继承自上级组织' : '请先选择所属机构'"
                            style="width: 100%" :clearable="!isAddSub" :disabled="!editForm.DepartmentId || isAddSub"
                            @change="handleCampusChange">
                            <el-option v-for="item in campusOptions" :key="item.Id" :label="item.Name" :value="item.Id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级组织" prop="ParentId">
                        <el-select v-model="editForm.ParentId" placeholder="请选择上级（可为空）" clearable :disabled="isAddSub">
                            <el-option :label="'顶级'" :value="0"></el-option>
                            <el-option v-for="n in parentOptions" :key="n.Id" :label="n.Name" :value="n.Id"></el-option>
                        </el-select>
                    </el-form-item>

                    <!-- 管理员：通讯录多选；可勾选「全部教职工有效」。最后更新：2026-09-22 -->
                    <el-form-item label="管理员" prop="AdminIdsArray">
                        <div class="org-admin-hint">
                            勾选「全部教职工有效」表示<strong>组织层面</strong>本校教师均可管理该组织；若要按<strong>单次活动</strong>限定负责人，请到「活动事件」里为每条活动指定「指导老师」。</div>
                        <el-checkbox v-model="editForm.AllTeachersAsAdmins" @change="handleAllTeachersAsAdminsChange"
                            style="margin-bottom: 8px; display: block;">全部教职工有效（无需指定）</el-checkbox>
                        <div class="ps-pick-summary">
                            <span v-if="editForm.AllTeachersAsAdmins" class="muted-text">已设为全部教职工有效</span>
                            <span v-else-if="orgAdminSelectedItems.length">已选 <strong>{{ orgAdminSelectedItems.length }}</strong> 人</span>
                            <span v-else class="muted-text">请从内部通讯录选择管理员</span>
                            <el-button
                                type="primary"
                                size="small"
                                plain
                                :disabled="!editForm.DepartmentId || !editForm.CampusId || editForm.AllTeachersAsAdmins"
                                @click="openOrgAdminPicker">选择教职工</el-button>
                            <el-button
                                v-if="orgAdminSelectedItems.length && !editForm.AllTeachersAsAdmins"
                                type="text"
                                size="small"
                                @click="clearOrgAdmins">清空</el-button>
                        </div>
                        <div v-if="!editForm.AllTeachersAsAdmins && orgAdminSelectedItems.length" class="ps-pick-tags">
                            <el-tag
                                v-for="item in orgAdminSelectedPreview"
                                :key="'adm-' + item.id"
                                size="mini"
                                closable
                                disable-transitions
                                @close="removeOrgAdmin(item.id)">
                                {{ item.name }}
                            </el-tag>
                            <span v-if="orgAdminSelectedItems.length > 8" class="ps-pick-more">等 {{ orgAdminSelectedItems.length }} 人</span>
                        </div>
                    </el-form-item>

                    <el-form-item label="短标识" prop="ShortTag">
                        <el-input v-model="editForm.ShortTag" maxlength="10" show-word-limit
                            placeholder="最多10位"></el-input>
                    </el-form-item>

                    <el-form-item label="层级" prop="Level">
                        <el-input v-model="editForm.Level" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="描述" prop="Description">
                        <el-input type="textarea" v-model="editForm.Description" :rows="3"></el-input>
                    </el-form-item>

                    <!-- 组织人员：家校通讯录多选。最后更新：2026-09-22 -->
                    <el-form-item label="人员" prop="MemberUserIds">
                        <div class="ps-pick-summary">
                            <span v-if="orgMemberSelectedItems.length">已选 <strong>{{ orgMemberSelectedItems.length }}</strong> 人</span>
                            <span v-else class="muted-text">请从家校通讯录选择学生</span>
                            <el-button
                                type="primary"
                                size="small"
                                plain
                                :disabled="!editForm.DepartmentId || !editForm.CampusId"
                                @click="openOrgMemberPicker">选择学生</el-button>
                            <el-button
                                v-if="orgMemberSelectedItems.length"
                                type="text"
                                size="small"
                                @click="clearOrgMembers">清空</el-button>
                        </div>
                        <div v-if="orgMemberSelectedItems.length" class="ps-pick-tags">
                            <el-tag
                                v-for="item in orgMemberSelectedPreview"
                                :key="'mem-' + item.id"
                                size="mini"
                                closable
                                disable-transitions
                                @close="removeOrgMember(item.id)">
                                {{ item.name }}
                            </el-tag>
                            <span v-if="orgMemberSelectedItems.length > 8" class="ps-pick-more">等 {{ orgMemberSelectedItems.length }} 人</span>
                        </div>
                    </el-form-item>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="editFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="editSubmit" :loading="editLoading">确定</el-button>
                </div>
            </el-dialog>

            <!-- 活动参与人员弹窗。最后更新：2026-10-20 -->
            <el-dialog
                :title="eventParticipantTitle || '活动参与人员'"
                :visible.sync="eventParticipantDialogVisible"
                width="760px"
                :close-on-click-modal="false"
                append-to-body
                custom-class="kq-dept-view-dialog kq-member-view-dialog">
                <div class="kq-view-head">
                    <div class="kq-view-head-item">
                        <span class="label">活动：</span>
                        <span class="val">{{ eventParticipantEventName || '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">时间：</span>
                        <span class="val">{{ eventParticipantTime || '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">总数：</span>
                        <span class="val count-badge">{{ eventParticipantRows.length }} 人</span>
                    </div>
                </div>

                <div class="kq-view-toolbar">
                    <el-input
                        v-model="eventParticipantFilterKey"
                        size="small"
                        placeholder="搜索参与人姓名..."
                        prefix-icon="el-icon-search"
                        clearable
                        class="kq-view-search-input" />
                    <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllEventParticipantNames">
                        复制全部姓名
                    </el-button>
                </div>

                <div class="kq-view-table-wrap">
                    <el-table :data="pagedEventParticipantRows" size="small" max-height="320" border stripe class="kq-view-table">
                        <el-table-column label="序号" width="70" align="center">
                            <template slot-scope="scope">
                                {{ (eventParticipantPage - 1) * eventParticipantPageSize + scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="参与人" min-width="160">
                            <template slot-scope="scope">
                                <span class="dept-text">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dormText" label="宿舍" min-width="160" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.dormText || '—' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleMemberName(scope.row.name)">复制</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="kq-view-empty">暂无参与人员</div>
                    </el-table>
                </div>
                <div class="kq-view-pager">
                    <el-pagination
                        layout="total, sizes, prev, pager, next"
                        :total="filteredEventParticipantTotal"
                        :current-page.sync="eventParticipantPage"
                        :page-size.sync="eventParticipantPageSize"
                        :page-sizes="[20, 50, 100]"
                        :pager-count="5"
                        small
                    />
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="eventParticipantDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 专业组类型维护 -->
            <el-dialog
                :title="professionalGroupDialogTitle"
                :visible.sync="professionalGroupDialogVisible"
                width="720px"
                class="professional-group-dialog"
                :close-on-click-modal="false"
                append-to-body
                @opened="handleProfessionalGroupDialogOpened">
                <div class="pg-dialog-inner">
                    <div class="pg-toolbar">
                        <div class="pg-toolbar-left">
                            <el-select
                                v-model="professionalGroupCampusId"
                                filterable
                                size="small"
                                placeholder="请选择校区"
                                style="width: 180px;"
                                @change="handleProfessionalGroupCampusChange">
                                <el-option
                                    v-for="item in campusOptions"
                                    :key="'pg-campus-' + item.Id"
                                    :label="item.Name"
                                    :value="item.Id">
                                </el-option>
                            </el-select>
                            <el-input
                                v-model="professionalGroupKeyword"
                                clearable
                                size="small"
                                prefix-icon="el-icon-search"
                                placeholder="搜索专业组名称"
                                style="width: 200px; margin-left: 8px;"
                                :disabled="!professionalGroupCampusId"
                                @input="handleProfessionalGroupFilterChange"
                                @clear="handleProfessionalGroupFilterChange"
                                @keyup.enter.native="handleProfessionalGroupFilterChange">
                            </el-input>
                            <el-select
                                v-model="professionalGroupStatusFilter"
                                clearable
                                size="small"
                                placeholder="状态"
                                style="width: 110px; margin-left: 8px;"
                                :disabled="!professionalGroupCampusId"
                                @change="handleProfessionalGroupFilterChange">
                                <el-option label="全部状态" value=""></el-option>
                                <el-option label="启用" value="1"></el-option>
                                <el-option label="停用" value="0"></el-option>
                            </el-select>
                        </div>
                        <el-button type="primary" size="small" icon="el-icon-plus"
                            :disabled="!professionalGroupCampusId"
                            @click="openProfessionalGroupForm()">新增专业组</el-button>
                    </div>

                    <div class="pg-table-wrap" v-loading="professionalGroupLoading">
                        <el-table
                            ref="professionalGroupTable"
                            :data="pagedProfessionalGroupList"
                            size="small"
                            stripe
                            height="100%"
                            class="pg-table"
                            :empty-text="professionalGroupCampusId ? '当前校区暂无专业组，请先新增' : '请先选择校区'">
                            <el-table-column type="index" label="序号" width="60" align="center"
                                :index="professionalGroupIndexMethod"></el-table-column>
                            <el-table-column prop="Name" label="名称" min-width="180" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Sort" label="排序" width="80" align="center"></el-table-column>
                            <el-table-column label="状态" width="90" align="center">
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.Enabled"
                                        :active-value="true"
                                        :inactive-value="false"
                                        :disabled="!!scope.row._statusSaving"
                                        :title="scope.row.Enabled ? '已启用，点击停用' : '已停用，点击启用'"
                                        @change="(val) => toggleProfessionalGroupEnabled(scope.row, val)">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="118" align="center" class-name="pg-op-col">
                                <template slot-scope="scope">
                                    <div class="table-op-pair table-op-pair--compact">
                                        <el-button type="text" size="small" class="table-op-link"
                                            @click="openProfessionalGroupForm(scope.row)">编辑</el-button>
                                        <el-button type="text" size="small" class="table-op-link table-op-link--danger"
                                            @click="removeProfessionalGroup(scope.row)">删除</el-button>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="pg-pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next"
                            :current-page.sync="professionalGroupPage"
                            :page-size="professionalGroupPageSize"
                            :total="filteredProfessionalGroupTotal"
                            @current-change="handleProfessionalGroupPageChange">
                        </el-pagination>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="professionalGroupDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <el-dialog
                :title="professionalGroupForm.Id ? '编辑专业组' : '新增专业组'"
                :visible.sync="professionalGroupFormVisible"
                width="440px"
                append-to-body
                :close-on-click-modal="false">
                <el-form :model="professionalGroupForm" label-width="80px" size="small">
                    <el-form-item label="校区">
                        <el-input :value="getCampusName(professionalGroupCampusId)" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="名称" required>
                        <el-input v-model.trim="professionalGroupForm.Name" maxlength="100"
                            show-word-limit placeholder="请输入专业组名称"></el-input>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number v-model="professionalGroupForm.Sort" :min="0" :max="9999"
                            controls-position="right"></el-input-number>
                    </el-form-item>
                    <el-form-item label="启用">
                        <el-switch v-model="professionalGroupForm.Enabled"></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="professionalGroupFormVisible = false">取消</el-button>
                    <el-button type="primary" size="small" :loading="professionalGroupSaving"
                        @click="saveProfessionalGroup">保存</el-button>
                </span>
            </el-dialog>

            <!-- 活动事件对话框 -->
            <el-dialog
                :title="currentOrgForEvents && currentOrgForEvents.Name ? (currentOrgForEvents.Name + ' - 活动事件') : '活动事件'"
                :visible.sync="eventDialogVisible" width="90%" class="event-list-dialog"
                :close-on-click-modal="false"
                top="8vh" append-to-body @opened="onEventDialogOpened">
                <div class="event-dialog-inner">
                <div class="event-list-toolbar">
                    <el-select v-model="eventsStatus" clearable placeholder="活动状态" size="small" style="width: 120px; margin-right: 8px;"
                        @change="handleEventsStatusChange">
                        <el-option label="全部状态" value=""></el-option>
                        <el-option label="未开始" value="NotStarted"></el-option>
                        <el-option label="进行中" value="Ongoing"></el-option>
                        <el-option label="已结束" value="Ended"></el-option>
                    </el-select>
                    <el-select v-model="eventsProfessionalGroupTypeId" clearable filterable placeholder="专业组" size="small"
                        style="width: 130px; margin-right: 8px;" @change="handleEventsFilterChange">
                        <el-option v-for="item in professionalGroupTypes" :key="'event-filter-group-' + item.Id"
                            :label="item.Name" :value="item.Id"></el-option>
                    </el-select>
                    <el-input v-model="eventsKeyword" clearable placeholder="标题/描述" size="small"
                        style="width: 150px; margin-right: 8px;" @keyup.enter.native="handleEventsFilterChange"></el-input>
                    <el-date-picker v-model="eventsDateRange" type="daterange" size="small" value-format="yyyy-MM-dd"
                       start-placeholder="开始日期" end-placeholder="结束日期"
                        style="width: 240px; margin-right: 8px;" @change="handleEventsFilterChange"></el-date-picker>
                    <el-button size="small" @click="exportExcel">导出活动明细</el-button>
                    <el-button size="small" type="warning" plain @click="exportCompetitionExcel">导出竞赛表格</el-button>
                    <el-button type="primary" size="small" @click="addEventOpen">新增活动</el-button>
                </div>

                <div class="event-table-wrap" ref="eventTableWrap">
                    <el-table
                        ref="eventListTable"
                        :data="events"
                        v-loading="eventsLoading"
                        row-key="Id"
                        class="event-list-table"
                        stripe
                        size="mini"
                        :height="eventListTableHeight"
                        style="width: 100%;">
                    <!-- 标题 + 描述合并；描述始终占第二行（空则 —）。最后更新：2026-10-28 -->
                    <el-table-column label="标题 / 描述" min-width="180" align="left" header-align="left"
                        class-name="event-merge-left-col" label-class-name="event-merge-left-col" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="event-title-desc-cell"
                                :title="((scope.row.Title || '') + (scope.row.Description ? ('\n' + scope.row.Description) : '')).trim()">
                                <div class="event-title-line">{{ scope.row.Title || '—' }}</div>
                                <div class="event-desc-line">{{ scope.row.Description || '—' }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ProfessionalGroupTypeName" label="专业组" min-width="90" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.ProfessionalGroupTypeName || '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="eventStatusTagType(scope.row.Status)">
                                {{ scope.row.StatusText || eventStatusText(scope.row.Status) || '—' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <!-- 活动起止 + 创建时间合并；地点单独展示。最后更新：2026-10-28 -->
                    <el-table-column label="活动时间 / 创建" min-width="168" align="left" header-align="left"
                        class-name="event-merge-left-col" label-class-name="event-merge-left-col" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="event-time-merge-cell"
                                :title="(formatDateOnly(scope.row.StartDate) + ' - ' + formatDateOnly(scope.row.EndDate) + '\n创建：' + (formatDateTime(scope.row.CreateTime) || '—'))">
                                <div class="event-time-line">{{ formatDateOnly(scope.row.StartDate) }} - {{ formatDateOnly(scope.row.EndDate) }}</div>
                                <div class="event-create-line">创建 {{ formatDateTime(scope.row.CreateTime) || '—' }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="地点" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.Location || '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="参与人员" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showEventParticipants(scope.row)">
                                查看 ({{ (scope.row.ParticipantUserNames && (typeof scope.row.ParticipantUserNames ===
                                    'string' ? scope.row.ParticipantUserNames.split(',').length :
                                    scope.row.ParticipantUserNames.length)) || (scope.row.ParticipantNames &&
                                        scope.row.ParticipantNames.length) || (scope.row.MemberIds ? (typeof scope.row.MemberIds
                                            === 'string' ? (scope.row.MemberIds.split(',').length) : scope.row.MemberIds.length) :
                                            0) }})
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="指导老师 / 维护者" min-width="160" align="left" header-align="left"
                        class-name="event-merge-left-col" label-class-name="event-merge-left-col" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div class="event-teacher-merge-cell">
                                <span class="event-teacher-label">老师</span>
                                <div class="event-teacher-value">
                                    <div v-if="getAdminNamesList(scope.row.ManagerTeacherNames).length" class="admin-tags-inline">
                                        <el-tag v-for="(name, idx) in getAdminNamesList(scope.row.ManagerTeacherNames).slice(0, 2)"
                                            :key="'evm-' + idx" size="mini" type="primary" effect="plain">{{ name }}</el-tag>
                                        <el-tooltip v-if="getAdminNamesList(scope.row.ManagerTeacherNames).length > 2"
                                            placement="top"
                                            :content="getAdminNamesList(scope.row.ManagerTeacherNames).slice(2).join('、')">
                                            <el-tag size="mini" type="info" effect="plain" class="admin-more-tag">
                                                +{{ getAdminNamesList(scope.row.ManagerTeacherNames).length - 2 }}
                                            </el-tag>
                                        </el-tooltip>
                                    </div>
                                    <span v-else class="admin-empty">—</span>
                                </div>
                                <span class="event-teacher-label">维护</span>
                                <div class="event-teacher-value">
                                    <div v-if="getAdminNamesList(scope.row.ManagerSetterTeacherNames).length" class="admin-tags-inline">
                                        <el-tag v-for="(name, idx) in getAdminNamesList(scope.row.ManagerSetterTeacherNames).slice(0, 2)"
                                            :key="'evms-' + idx" size="mini" type="info" effect="plain">{{ name }}</el-tag>
                                        <el-tooltip v-if="getAdminNamesList(scope.row.ManagerSetterTeacherNames).length > 2"
                                            placement="top"
                                            :content="getAdminNamesList(scope.row.ManagerSetterTeacherNames).slice(2).join('、')">
                                            <el-tag size="mini" type="info" effect="plain" class="admin-more-tag">
                                                +{{ getAdminNamesList(scope.row.ManagerSetterTeacherNames).length - 2 }}
                                            </el-tag>
                                        </el-tooltip>
                                    </div>
                                    <span v-else class="admin-empty">全体教职工</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="118" align="center" class-name="event-op-col">
                        <template slot-scope="scope">
                            <div class="table-op-pair table-op-pair--compact">
                                <el-button type="text" class="table-op-link" size="small" @click="editEventOpen(scope.row)">编辑</el-button>
                                <el-button type="text" class="table-op-link table-op-link--danger" size="small" @click="deleteEventRow(scope.row)">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                </div>

                <div class="pagination-container event-pagination-in-dialog">
                    <el-pagination background :current-page.sync="eventsPage" :page-size="eventsPageSize"
                        :total="eventsTotal" layout="total, prev, pager, next, jumper"
                        @current-change="handleEventsPageChange">
                    </el-pagination>
                </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="eventDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <!-- 活动表单对话框 -->
            <el-dialog title="活动事件" :visible.sync="eventFormVisible" width="40%" :close-on-click-modal="false">
                <el-form :model="eventForm" :rules="eventFormRules" ref="eventForm" label-width="120px" class="event-form">
                    <el-form-item label="标题" prop="Title">
                        <el-input v-model="eventForm.Title"></el-input>
                    </el-form-item>
                    <el-form-item label="专业组" prop="ProfessionalGroupTypeId">
                        <el-select v-model="eventForm.ProfessionalGroupTypeId" clearable filterable
                            placeholder="请选择专业组" style="width:100%">
                            <el-option v-for="item in professionalGroupTypes" :key="'event-group-' + item.Id"
                                :label="item.Name" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动时间" prop="StartDate">
                        <el-date-picker v-model="eventDateRange" type="daterange"
                            start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%"></el-date-picker>
                    </el-form-item>

                    <el-form-item label="调度模式" prop="ScheduleMode">
                        <el-radio-group v-model="eventForm.ScheduleMode">
                            <el-radio :label="1">按日期范围</el-radio>
                            <el-radio :label="2">按周次</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 周次模式下先选择星期（周一~周日），再选择是否使用统一时段 -->
                    <el-form-item v-if="eventForm.ScheduleMode === 2" label="选择星期">
                        <div style="display:flex; flex-wrap:nowrap; overflow-x:auto; align-items:center; padding:4px 0">
                            <div v-for="(w, idx) in weekdaySessions" :key="w.weekday"
                                style="margin-right:12px; white-space:nowrap">
                                <el-checkbox v-model="w.enabled"
                                    :disabled="(availableWeekdays.length > 0) && !availableWeekdays.includes(w.weekday)">{{
                                        w.name
                                    }}</el-checkbox>
                            </div>
                        </div>
                    </el-form-item>

                    <el-form-item label="使用统一时段">
                        <el-switch v-model="eventForm.IsUnifiedTimeSlot"></el-switch>
                    </el-form-item>

                    <el-form-item v-if="eventForm.IsUnifiedTimeSlot" label="统一时段">
                        <div style="display:flex; align-items:center; gap:12px">
                            <el-time-picker v-model="eventForm.UnifiedStartTime" placeholder="开始时刻"
                                value-format="HH:mm:ss" style="width:160px"></el-time-picker>
                            <el-time-picker v-model="eventForm.UnifiedEndTime" placeholder="结束时刻"
                                value-format="HH:mm:ss" style="width:160px"></el-time-picker>
                        </div>
                    </el-form-item>

                    <el-form-item v-if="!eventForm.IsUnifiedTimeSlot && eventForm.ScheduleMode === 1" label="每日时段">
                        <div v-if="dateSessions.length === 0">请先选择开始/结束日期以生成每天的时段条目。</div>
                        <div v-for="(ds, idx) in pagedDateSessions()" :key="ds.date" style="margin-bottom:8px">
                            <el-row :gutter="8" type="flex" align="middle">
                                <el-col :span="6">{{ ds.date }}</el-col>
                                <el-col :span="9">
                                    <el-time-picker v-model="ds.startTime" placeholder="开始时刻" value-format="HH:mm:ss"
                                        style="width:100%"></el-time-picker>
                                </el-col>
                                <el-col :span="9">
                                    <el-time-picker v-model="ds.endTime" placeholder="结束时刻" value-format="HH:mm:ss"
                                        style="width:100%"></el-time-picker>
                                </el-col>
                            </el-row>
                        </div>
                        <div style="text-align:right; margin-top:8px" v-if="dateSessions.length > datePageSize">
                            <el-pagination background :current-page.sync="datePage" :page-size="datePageSize"
                                :total="dateSessions.length" layout="total, prev, pager, next, jumper"
                                @current-change="val => datePage = val">
                            </el-pagination>
                        </div>
                    </el-form-item>

                    <el-form-item v-if="!eventForm.IsUnifiedTimeSlot && eventForm.ScheduleMode === 2" label="周次时段">
                        <div style="display:flex; flex-wrap:wrap">
                            <div v-for="(w, idx) in weekdaySessions.filter(x => x.enabled)" :key="w.weekday"
                                class="week-day-box">
                                <div class="week-day-container">
                                    <div class="weekday-label">{{ w.name }}</div>
                                    <el-time-picker class="week-time" v-model="w.startTime" placeholder="开始时刻"
                                        value-format="HH:mm:ss"></el-time-picker>
                                    <el-time-picker class="week-time" v-model="w.endTime" placeholder="结束时刻"
                                        value-format="HH:mm:ss"></el-time-picker>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <!-- 已移除周次下拉：按周次调度只需选择星期和时段 -->
                    <!-- 参与人员：组织成员受限名单。最后更新：2026-09-22 -->
                    <el-form-item label="参与人员" prop="ParticipantUserIds">
                        <div class="ps-pick-summary">
                            <span v-if="eventParticipantSelectedCount">已选 <strong>{{ eventParticipantSelectedCount }}</strong> 人</span>
                            <span v-else class="muted-text">从当前组织人员中选择</span>
                            <el-button type="primary" size="mini" plain :disabled="!eventParticipantOptions.length"
                                @click="openEventParticipantPicker">选择人员</el-button>
                            <el-button v-if="eventParticipantSelectedCount" type="text" size="mini"
                                @click="clearEventParticipants">清空</el-button>
                        </div>
                        <div v-if="eventParticipantSelectedCount" class="ps-pick-tags">
                            <el-tag
                                v-for="item in eventParticipantSelectedPreview"
                                :key="'ep-' + item.value"
                                size="mini"
                                closable
                                disable-transitions
                                @close="removeEventParticipant(item.value)">
                                {{ item.label }}
                            </el-tag>
                            <span v-if="eventParticipantSelectedCount > 8" class="ps-pick-more">等 {{ eventParticipantSelectedCount }} 人</span>
                        </div>
                    </el-form-item>
                    <!-- 指导老师：仅组织管理员候选。最后更新：2026-09-22 -->
                    <el-form-item label="指导老师" prop="ManagerTeacherUserIds">
                        <div class="event-mgr-hint">从当前组织管理员中选择可管理<strong>本条活动</strong>的教师。若组织管理员为“全体教职工”，此处可选全体教师。</div>
                        <div class="ps-pick-summary">
                            <span v-if="eventManagerSelectedCount">已选 <strong>{{ eventManagerSelectedCount }}</strong> 人</span>
                            <span v-else class="muted-text">{{ eventManagerOptions.length ? '可选，从组织管理员中选择' : '当前组织未配置管理员或未加载教师数据' }}</span>
                            <el-button type="primary" size="mini" plain :disabled="!eventManagerOptions.length"
                                @click="openEventManagerPicker">选择教职工</el-button>
                            <el-button v-if="eventManagerSelectedCount" type="text" size="mini"
                                @click="clearEventManagers">清空</el-button>
                        </div>
                        <div v-if="eventManagerSelectedCount" class="ps-pick-tags">
                            <el-tag
                                v-for="item in eventManagerSelectedPreview"
                                :key="'em-' + item.value"
                                size="mini"
                                closable
                                disable-transitions
                                @close="removeEventManager(item.value)">
                                {{ item.label }}
                            </el-tag>
                            <span v-if="eventManagerSelectedCount > 8" class="ps-pick-more">等 {{ eventManagerSelectedCount }} 人</span>
                        </div>
                    </el-form-item>
                    <!-- 指导老师维护者：仅已选指导老师子集。最后更新：2026-09-22 -->
                    <el-form-item label="指导老师维护者" prop="ManagerSetterTeacherUserIds">
                        <div class="event-mgr-hint">从当前已选「指导老师」中选择可维护名单的教师，确保维护者一定属于指导老师。</div>
                        <div class="ps-pick-summary">
                            <span v-if="eventManagerSetterSelectedCount">已选 <strong>{{ eventManagerSetterSelectedCount }}</strong> 人</span>
                            <span v-else class="muted-text">{{ eventManagerSetterOptions.length ? '可选，从指导老师中选择；留空则列表显示全体教职工' : '请先选择指导老师' }}</span>
                            <el-button type="primary" size="mini" plain :disabled="!eventManagerSetterOptions.length"
                                @click="openEventManagerSetterPicker">选择教职工</el-button>
                            <el-button v-if="eventManagerSetterSelectedCount" type="text" size="mini"
                                @click="clearEventManagerSetters">清空</el-button>
                        </div>
                        <div v-if="eventManagerSetterSelectedCount" class="ps-pick-tags">
                            <el-tag
                                v-for="item in eventManagerSetterSelectedPreview"
                                :key="'es-' + item.value"
                                size="mini"
                                closable
                                disable-transitions
                                @close="removeEventManagerSetter(item.value)">
                                {{ item.label }}
                            </el-tag>
                            <span v-if="eventManagerSetterSelectedCount > 8" class="ps-pick-more">等 {{ eventManagerSetterSelectedCount }} 人</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="描述" prop="Description">
                        <el-input type="textarea" v-model="eventForm.Description" :rows="3"></el-input>
                    </el-form-item>
                    <el-form-item label="活动地点" prop="Location">
                        <el-input v-model="eventForm.Location" placeholder="可选，填写活动地点或位置"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="eventFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="eventSubmit">保存</el-button>
                </div>
            </el-dialog>

            <!-- 按学生查询活动 -->
            <el-dialog 
                :title="studentEventDialogTitle"
                :visible.sync="studentEventDialogVisible"
                width="1080px"
                class="event-list-dialog student-event-query-dialog"
                :close-on-click-modal="false"
                top="8vh"
                append-to-body>
                <div class="event-dialog-inner">
                    <div class="student-event-query-bar">
                        <div class="ps-pick-summary student-event-student-pick">
                            <span v-if="studentEventQuery.studentId">
                                已选 <strong>{{ studentEventQuery.studentName || ('学生#' + studentEventQuery.studentId) }}</strong>
                            </span>
                            <span v-else class="muted-text">{{ DepartmentId ? '请选择一名学生' : '请先在左侧选择机构' }}</span>
                            <el-button type="primary" size="mini" plain :disabled="!DepartmentId" @click="openStudentEventPicker">选择学生</el-button>
                            <el-button v-if="studentEventQuery.studentId" type="text" size="mini" @click="clearStudentEventPick">清空</el-button>
                        </div>
                        <el-input
                            v-model="studentEventQuery.keyword"
                            placeholder="活动标题/描述"
                            clearable
                            style="width: 200px; margin-left: 8px;"
                            @keyup.enter.native="searchStudentEvents">
                        </el-input>
                        <el-button type="primary" style="margin-left: 8px;" :loading="studentEventsLoading" @click="searchStudentEvents">查询</el-button>
                    </div>
                    <p v-if="!DepartmentId" class="student-event-query-hint">提示：先在左侧机构树选择学校/校区，再选择学生查询。</p>

                    <div class="event-table-wrap student-event-table-wrap" style="margin-top: 12px;">
                        <el-table
                            :data="studentEvents"
                            v-loading="studentEventsLoading"
                            row-key="EventId"
                            class="event-list-table"
                            height="100%"
                            style="width:100%"
                            stripe
                            size="mini"
                            fit>
                            <el-table-column prop="OrganizationName" label="所属组织" min-width="100" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Title" label="活动标题" min-width="90" show-overflow-tooltip></el-table-column>
                            <el-table-column label="开始/结束" min-width="180" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    {{ formatDateOnly(scope.row.StartDate) }} - {{ formatDateOnly(scope.row.EndDate) }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Location" label="地点" min-width="70" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Description" label="描述" min-width="80" show-overflow-tooltip></el-table-column>
                            <el-table-column label="指导老师" min-width="100" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span>{{ scope.row.ManagerTeacherNames || '—' }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="90" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" class="student-event-detail-btn" @click="showStudentEventDetail(scope.row)">明细</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                    <div class="pagination-container event-pagination-in-dialog">
                        <el-pagination
                            background
                            :current-page.sync="studentEventsPage"
                            :page-size="studentEventsPageSize"
                            :total="studentEventsTotal"
                            layout="total, prev, pager, next, jumper"
                            @current-change="handleStudentEventsPageChange">
                        </el-pagination>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="studentEventDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <person-scope-picker-dialog
                :visible.sync="studentEventPickerVisible"
                directory-scope="teaching"
                :show-scope-tabs="false"
                :scope-department-id="DepartmentId"
                :value="studentEventQuery.studentId"
                :label="studentEventQuery.studentName"
                title="选择学生"
                @confirm="onStudentEventPicked"
            />

            <!-- 学生活动明细弹窗 -->
            <el-dialog
                :title="studentEventDetailTitle"
                :visible.sync="studentEventDetailVisible"
                width="720px"
                append-to-body
                :close-on-click-modal="false">
                <div v-if="studentEventDetailRow" class="student-event-detail-body">
                    <el-descriptions :column="2" border size="small">
                        <el-descriptions-item label="所属组织">{{ studentEventDetailRow.OrganizationName || '—' }}</el-descriptions-item>
                        <el-descriptions-item label="活动标题">{{ studentEventDetailRow.Title || '—' }}</el-descriptions-item>
                        <el-descriptions-item label="活动时间">
                            {{ formatDateOnly(studentEventDetailRow.StartDate) }} - {{ formatDateOnly(studentEventDetailRow.EndDate) }}
                        </el-descriptions-item>
                        <el-descriptions-item label="活动地点">{{ studentEventDetailRow.Location || '—' }}</el-descriptions-item>
                        <el-descriptions-item label="调度模式">{{ mapScheduleModeLabel(studentEventDetailRow.ScheduleMode) }}</el-descriptions-item>
                        <el-descriptions-item label="统一时段">
                            {{ studentEventDetailRow.IsUnifiedTimeSlot ? '是' : '否' }}
                            <span v-if="studentEventDetailRow.IsUnifiedTimeSlot">
                                （{{ formatTimeOnly(studentEventDetailRow.UnifiedStartTime) }} - {{ formatTimeOnly(studentEventDetailRow.UnifiedEndTime) }}）
                            </span>
                        </el-descriptions-item>
                        <el-descriptions-item v-if="studentEventDetailUseUnifiedSummary" label="场次说明" :span="2">
                            活动期间每天 {{ formatTimeOnly(studentEventDetailRow.UnifiedStartTime) }} - {{ formatTimeOnly(studentEventDetailRow.UnifiedEndTime) }}，共 {{ studentEventUnifiedDayCount }} 天
                        </el-descriptions-item>
                        <el-descriptions-item label="指导老师">{{ studentEventDetailRow.ManagerTeacherNames || '—' }}</el-descriptions-item>
                        <el-descriptions-item label="创建时间">{{ formatDateTime(studentEventDetailRow.CreateTime) }}</el-descriptions-item>
                        <el-descriptions-item label="描述" :span="2">{{ studentEventDetailRow.Description || '—' }}</el-descriptions-item>
                    </el-descriptions>

                    <div v-if="!studentEventDetailUseUnifiedSummary" class="student-event-detail-sessions">
                        <div class="student-event-detail-sessions-title">场次/时段明细</div>
                        <div v-if="studentEventSessionRows.length" class="student-event-session-count-inline">共 {{ studentEventSessionRows.length }} 条</div>
                        <el-table
                            v-if="studentEventSessionRows.length"
                            :data="pagedStudentEventSessionRows"
                            size="mini"
                            stripe
                            border
                            style="width: 100%;">
                            <el-table-column prop="dateLabel" label="日期/星期" min-width="120"></el-table-column>
                            <el-table-column prop="timeRange" label="时段" min-width="120"></el-table-column>
                        </el-table>
                        <div v-if="studentEventSessionRows.length > studentEventSessionPageSize" class="student-event-session-pagination">
                            <el-pagination
                                background
                                small
                                :current-page.sync="studentEventSessionPage"
                                :page-size="studentEventSessionPageSize"
                                :total="studentEventSessionRows.length"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleStudentEventSessionPageChange">
                            </el-pagination>
                        </div>
                        <div v-else-if="!studentEventSessionRows.length && studentEventDetailRow.SessionSummary" class="student-event-detail-fallback">
                            {{ studentEventDetailRow.SessionSummary }}
                        </div>
                        <div v-else-if="!studentEventSessionRows.length" class="student-event-detail-fallback">暂无场次明细</div>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="studentEventDetailVisible = false">关闭</el-button>
                </span>
            </el-dialog>

            <!-- 成员详情弹窗。最后更新：2026-09-22 -->
            <el-dialog :title="memberDialogTitle || '组织成员'" :visible.sync="memberDialogVisible" width="760px"
                :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog kq-member-view-dialog">
                <div class="kq-view-head">
                    <div class="kq-view-head-item">
                        <span class="label">组织：</span>
                        <span class="val">{{ currentMemberOrg ? currentMemberOrg.Name : '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">所属部门：</span>
                        <span class="val">{{ currentMemberOrg ? currentMemberOrg.DepartmentName : '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">总数：</span>
                        <span class="val count-badge">{{ memberDialogList ? memberDialogList.length : 0 }} 名成员</span>
                    </div>
                </div>

                <div class="kq-view-toolbar">
                    <el-input v-model="memberDialogFilterKey" size="small" placeholder="搜索成员姓名..." prefix-icon="el-icon-search"
                        clearable class="kq-view-search-input" />
                    <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllMemberNames">
                        复制全部姓名
                    </el-button>
                </div>

                <div class="kq-view-table-wrap">
                    <el-table :data="pagedMemberDialogList" size="small" max-height="320" border stripe class="kq-view-table">
                        <el-table-column label="序号" width="70" align="center">
                            <template slot-scope="scope">
                                {{ (memberDialogPage - 1) * memberDialogPageSize + scope.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="成员姓名" min-width="240">
                            <template slot-scope="scope">
                                <span class="dept-text">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleMemberName(scope.row.name)">复制</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="kq-view-empty">暂无匹配的成员</div>
                    </el-table>
                </div>
                <div class="kq-view-pager">
                    <el-pagination
                        layout="total, sizes, prev, pager, next"
                        :total="filteredMemberDialogTotal"
                        :current-page.sync="memberDialogPage"
                        :page-size.sync="memberDialogPageSize"
                        :page-sizes="[20, 50, 100]"
                        :pager-count="5"
                        small
                    />
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="memberDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 管理员详情弹窗。最后更新：2026-09-08 -->
            <el-dialog :title="adminDialogTitle" :visible.sync="adminDialogVisible" width="600px"
                :close-on-click-modal="false" append-to-body custom-class="kq-dept-view-dialog">
                <div class="kq-view-head">
                    <div class="kq-view-head-item">
                        <span class="label">组织：</span>
                        <span class="val">{{ currentAdminOrg ? currentAdminOrg.Name : '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">所属部门：</span>
                        <span class="val">{{ currentAdminOrg ? currentAdminOrg.DepartmentName : '-' }}</span>
                    </div>
                    <div class="kq-view-head-item">
                        <span class="label">总数：</span>
                        <span class="val count-badge">{{ adminDialogTotalText }}</span>
                    </div>
                </div>

                <div class="kq-view-toolbar">
                    <el-input v-model="adminDialogFilterKey" size="small" placeholder="搜索管理员姓名..." prefix-icon="el-icon-search"
                        clearable class="kq-view-search-input" />
                    <el-button size="small" type="primary" plain icon="el-icon-document-copy" @click="copyAllAdminNames">
                        复制全部姓名
                    </el-button>
                </div>

                <div class="kq-view-table-wrap">
                    <el-table :data="filteredAdminDialogList" size="small" max-height="320" border stripe class="kq-view-table">
                        <el-table-column type="index" label="序号" width="70" align="center" />
                        <el-table-column prop="name" label="管理员姓名" min-width="240">
                            <template slot-scope="scope">
                                <span class="dept-text">{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copySingleAdminName(scope.row.name)">复制</el-button>
                            </template>
                        </el-table-column>
                        <div slot="empty" class="kq-view-empty">暂无匹配的管理员</div>
                    </el-table>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="adminDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 组织管理员：内部通讯录多选。创建于 2026-09-22 -->
            <person-scope-multi-picker-dialog
                :visible.sync="orgAdminPickerVisible"
                directory-scope="internal"
                :show-scope-tabs="false"
                :scope-department-id="editForm.DepartmentId || DepartmentId"
                title="选择组织管理员"
                :value="orgAdminSelectedItems"
                @confirm="onOrgAdminsPicked"
            />
            <!-- 组织人员：家校通讯录多选。创建于 2026-09-22 -->
            <person-scope-multi-picker-dialog
                :visible.sync="orgMemberPickerVisible"
                directory-scope="teaching"
                :show-scope-tabs="false"
                :scope-department-id="editForm.DepartmentId || DepartmentId"
                title="选择组织人员"
                :value="orgMemberSelectedItems"
                @confirm="onOrgMembersPicked"
            />
            <!-- 活动事件受限名单选人。创建于 2026-09-22 -->
            <flat-person-multi-picker-dialog
                :visible.sync="eventParticipantPickerVisible"
                title="选择参与人员"
                hint="可选范围为当前组织的人员成员。"
                empty-text="当前组织暂无人员，请先在编辑组织中添加人员"
                :options="eventParticipantOptions"
                :value="eventForm.ParticipantUserIds"
                @confirm="onEventParticipantsPicked"
            />
            <flat-person-multi-picker-dialog
                :visible.sync="eventManagerPickerVisible"
                title="选择指导老师"
                hint="可选范围来自当前组织的管理员；若组织设为全部教职工有效，则可选本校教师。"
                empty-text="当前组织未配置管理员"
                :options="eventManagerFlatOptions"
                :value="eventForm.ManagerTeacherUserIds"
                @confirm="onEventManagersPicked"
            />
            <flat-person-multi-picker-dialog
                :visible.sync="eventManagerSetterPickerVisible"
                title="选择指导老师维护者"
                hint="仅可从当前已选指导老师中选择。"
                empty-text="请先选择指导老师"
                :options="eventManagerSetterFlatOptions"
                :value="eventForm.ManagerSetterTeacherUserIds"
                @confirm="onEventManagerSettersPicked"
            />
        </section>
    </section>
</template>

<script>
import { getOrganizations, addOrganization, updateOrganization, deleteOrganization, getEventManagerCandidates, getProfessionalGroupTypes, addProfessionalGroupType, updateProfessionalGroupType, deleteProfessionalGroupType, getEventOverviewPermissions, updateEventOverviewPermissions, getCampusList, getEvents, getEventsByStudent, addEvent, updateEvent, deleteEvent, getMembers, exportEventsExcel, exportCompetitionEventsExcel } from '../../api/modules/misc';
import { getSchoolDepartmentTree } from '../../api/modules/department';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane';
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog';
import PersonScopePickerDialog from '../../components/PersonScopePickerDialog';
import FlatPersonMultiPickerDialog from '../../components/FlatPersonMultiPickerDialog';

export default {
    components: { Toolbar, DepartmentPane, PersonScopeMultiPickerDialog, PersonScopePickerDialog, FlatPersonMultiPickerDialog },
    data() {
        return {
            exportLoading: false, // 导出加载状态
            organizations: [],
            listLoading: false,
            page: 1,
            PageSize: 10,
            total: 0,
            buttonList: [],
            eventOverviewPermissionDialogVisible: false,
            eventOverviewPermissionSaving: false,
            eventOverviewPermissionForm: {
                SchoolId: 0,
                CampusId: null,
                ViewTeacherMasterIds: '',
                MaintainTeacherMasterIds: '',
                DeleteTeacherMasterIds: ''
            },
            overviewTeacherPickerVisible: false,
            overviewPickerRole: 'view',
            overviewPickerItems: [],
            overviewViewSelectedItems: [],
            overviewMaintainSelectedItems: [],
            overviewDeleteSelectedItems: [],
            /** 总览权限打开/加载后的人员快照，用于判断是否改动。最后更新：2026-10-19 */
            overviewPermissionBaseline: '',
            searchList: [
                { label: '名称', key: 'name' },
                { label: '校区', key: 'campusId', type: 'select', clearable: true, options: [] }
            ],
            campusOptions: [],
            DepartmentId: 0,

            // 编辑表单
            editFormVisible: false,
            dialogTitle: '',
            editLoading: false,
            editForm: { Id: 0, ParentId: 0, Name: '', ShortTag: '', Level: 1, Description: '', Dids: [], DepartmentId: 0, CampusId: null, AdminIdsArray: [], AllTeachersAsAdmins: false, MemberUserIds: [] },
            // 编辑组织时「全部教职工有效」切换前的管理员草稿缓存（未保存前用于回填）
            adminIdsDraftBeforeAllTeachers: [],
            adminItemsDraftBeforeAllTeachers: [],
            /** 组织管理员已选明细（通讯录多选） */
            orgAdminSelectedItems: [],
            orgAdminPickerVisible: false,
            /** 组织人员已选明细（家校多选） */
            orgMemberSelectedItems: [],
            orgMemberPickerVisible: false,
            editFormRules: {
                Name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                CampusId: [{ required: true, message: '请选择所属校区', trigger: 'change' }],
                ShortTag: [
                    { required: true, message: '请输入短标识', trigger: 'blur' },
                    { max: 10, message: '短标识最多10个字符', trigger: 'blur' }
                ]
            },

            parentOptions: [],
            isAddSub: false,
            // 所属机构选择项
            options: [],
            isResouceShow: 0,
            filters: {},
            /** 活动表单中「指导老师」的教师选项 */
            eventFormTeacherMasterList: [],
            /** 当前校区可用的活动专业组类型 */
            professionalGroupTypes: [],
            professionalGroupManageList: [],
            professionalGroupDialogVisible: false,
            professionalGroupFormVisible: false,
            professionalGroupLoading: false,
            professionalGroupSaving: false,
            professionalGroupCampusId: null,
            professionalGroupKeyword: '',
            professionalGroupStatusFilter: '',
            professionalGroupPage: 1,
            professionalGroupPageSize: 10,
            professionalGroupForm: { Id: 0, Name: '', Sort: 0, Enabled: true, CampusId: 0 },
            eventParticipantPickerVisible: false,
            eventManagerPickerVisible: false,
            eventManagerSetterPickerVisible: false,
            // 活动事件相关
            events: [],
            eventsLoading: false,
            /** 活动列表表格像素高度；须传数字，否则会被全站弹窗表格 max-height:420 限制。创建于 2026-10-20 */
            eventListTableHeight: 420,
            eventsPage: 1,
            eventsPageSize: 10,
            eventsTotal: 0,
            /** 活动事件列表状态筛选：空=全部，NotStarted/Ongoing/Ended */
            eventsStatus: '',
            eventsProfessionalGroupTypeId: null,
            eventsKeyword: '',
            eventsDateRange: [],
            eventDialogVisible: false,
            eventFormVisible: false,
            eventForm: {
                Id: 0, OrganizationId: 0, Title: '', Description: '', Location: '', StartDate: null, EndDate: null, ParticipantUserIds: [],
                ProfessionalGroupTypeId: null,
                ManagerTeacherUserIds: [],
                ManagerSetterTeacherUserIds: [],
                // 调度模式：1=DateRange, 2=Weekly
                ScheduleMode: 1,
                // 是否使用统一时段（true 使用 UnifiedStartTime/UnifiedEndTime）
                IsUnifiedTimeSlot: true,
                UnifiedStartTime: null,
                UnifiedEndTime: null,
                // 非统一时段时前端维护的会话/场次数组
                Sessions: []
            },
            eventFormRules: { Title: [{ required: true, message: '请输入活动标题', trigger: 'blur' }] },
            currentOrgForEvents: {},
            currentOrgMembers: [],
            // 按日期范围时的每日时段（前端展示/编辑用）
            dateSessions: [],
            // 每日时段分页
            datePage: 1,
            datePageSize: 5,
            // 按周次时每周日的时段设置（1..7）
            weekdaySessions: [
                { weekday: 1, name: '周一', enabled: false, startTime: null, endTime: null },
                { weekday: 2, name: '周二', enabled: false, startTime: null, endTime: null },
                { weekday: 3, name: '周三', enabled: false, startTime: null, endTime: null },
                { weekday: 4, name: '周四', enabled: false, startTime: null, endTime: null },
                { weekday: 5, name: '周五', enabled: false, startTime: null, endTime: null },
                { weekday: 6, name: '周六', enabled: false, startTime: null, endTime: null },
                { weekday: 7, name: '周日', enabled: false, startTime: null, endTime: null }
            ],
            // 按周选择项（例如第1周, 第2周）
            weekOptions: [],
            // 当前日期范围内可选的星期集合（1..7），为空表示未限制
            availableWeekdays: [],
            // 选中的周次数组（值为周序号，从1开始）
            // 在 eventForm 中也保持同步为 eventForm.WeekNumbers
            // 默认空表示全部或不限制
            // eventForm.WeekNumbers 已包含在 eventForm 对象
            memberDialogVisible: false,
            memberDialogList: [],
            memberDialogTitle: '',
            memberDialogFilterKey: '',
            memberDialogPage: 1,
            memberDialogPageSize: 20,
            currentMemberOrg: null,
            // 管理员详情弹窗状态。最后更新：2026-09-08
            adminDialogVisible: false,
            adminDialogTitle: '组织管理员',
            adminDialogList: [],
            adminDialogFilterKey: '',
            currentAdminOrg: null,
            eventParticipantDialogVisible: false,
            eventParticipantRows: [],
            eventParticipantTitle: '',
            eventParticipantEventName: '',
            eventParticipantTime: '',
            eventParticipantFilterKey: '',
            eventParticipantPage: 1,
            eventParticipantPageSize: 20,
            currentRow: null,
            // 按学生查询活动
            studentEventDialogVisible: false,
            studentEventDialogTitle: '按学生查询活动',
            studentEventQuery: { studentId: 0, studentName: '', keyword: '' },
            studentEventPickerVisible: false,
            studentEvents: [],
            studentEventsLoading: false,
            studentEventsPage: 1,
            studentEventsPageSize: 5,
            studentEventsTotal: 0,
            selectedStudentName: '',
            studentEventDetailVisible: false,
            studentEventDetailTitle: '活动明细',
            studentEventDetailRow: null,
            studentEventSessionPage: 1,
            studentEventSessionPageSize: 5
        };
    },
    created() {
        // 在创建时把活动时间校验规则注入到 eventFormRules（此时可安全引用 this）
        if (!this.eventFormRules) this.eventFormRules = {};
        this.eventFormRules.StartDate = [{ required: true, validator: this.validateEventDate, trigger: 'change' }];
    },
    computed: {
        /** 总览权限三级角色卡片数据。最后更新：2026-10-19 */
        overviewPermissionRoles() {
            return [
                {
                    key: 'view',
                    title: '查看权限',
                    desc: '可查看该校区全部社团活动',
                    icon: 'el-icon-view',
                    items: this.overviewViewSelectedItems || []
                },
                {
                    key: 'maintain',
                    title: '维护权限',
                    desc: '可新增、编辑活动，并维护活动管理员',
                    icon: 'el-icon-edit-outline',
                    items: this.overviewMaintainSelectedItems || []
                },
                {
                    key: 'delete',
                    title: '管理权限',
                    desc: '在维护权限基础上，允许删除活动',
                    icon: 'el-icon-s-check',
                    items: this.overviewDeleteSelectedItems || []
                }
            ];
        },
        /** 总览权限人员相对加载快照是否有改动。最后更新：2026-10-19 */
        overviewPermissionDirty() {
            if (!this.eventOverviewPermissionDialogVisible) return false;
            return this.buildOverviewPermissionSnapshot() !== this.overviewPermissionBaseline;
        },
        /** 专业组维护弹窗标题。最后更新：2026-10-19 */
        professionalGroupDialogTitle() {
            const campusName = this.getCampusName(this.professionalGroupCampusId);
            return campusName && campusName !== '-'
                ? `专业组类型维护（${campusName}）`
                : '专业组类型维护';
        },
        /** 专业组维护：按关键字和状态过滤。最后更新：2026-10-19 */
        filteredProfessionalGroupList() {
            const list = Array.isArray(this.professionalGroupManageList) ? this.professionalGroupManageList : [];
            const keyword = (this.professionalGroupKeyword || '').trim().toLowerCase();
            const status = this.professionalGroupStatusFilter;
            return list.filter((item) => {
                if (!item) return false;
                if (status === '1' && !item.Enabled) return false;
                if (status === '0' && item.Enabled) return false;
                if (!keyword) return true;
                return String(item.Name || '').toLowerCase().includes(keyword);
            });
        },
        filteredProfessionalGroupTotal() {
            return (this.filteredProfessionalGroupList || []).length;
        },
        /** 专业组维护：当前页数据。最后更新：2026-10-19 */
        pagedProfessionalGroupList() {
            const list = this.filteredProfessionalGroupList || [];
            const size = this.professionalGroupPageSize || 10;
            const page = this.professionalGroupPage || 1;
            const start = (page - 1) * size;
            return list.slice(start, start + size);
        },
        /** 弹窗中过滤后的成员姓名（不过页，供复制/总数）。最后更新：2026-09-22 */
        filteredMemberDialogNames() {
            const list = this.memberDialogList || [];
            const key = (this.memberDialogFilterKey || '').trim().toLowerCase();
            if (!key) return list;
            return list.filter(name => String(name).toLowerCase().includes(key));
        },
        filteredMemberDialogTotal() {
            return (this.filteredMemberDialogNames || []).length;
        },
        /** 弹窗当前页成员（仅渲染本页，避免一次挂载三千行）。最后更新：2026-09-22 */
        pagedMemberDialogList() {
            const list = this.filteredMemberDialogNames || [];
            const size = this.memberDialogPageSize || 20;
            const page = this.memberDialogPage || 1;
            const start = (page - 1) * size;
            return list.slice(start, start + size).map(name => ({ name }));
        },
        /** 活动参与人过滤列表。创建于 2026-10-20 */
        filteredEventParticipantRows() {
            const list = this.eventParticipantRows || [];
            const key = (this.eventParticipantFilterKey || '').trim().toLowerCase();
            if (!key) return list;
            return list.filter(item => {
                const name = String(item.name || '').toLowerCase();
                const dorm = String(item.dormText || '').toLowerCase();
                return name.includes(key) || dorm.includes(key);
            });
        },
        filteredEventParticipantTotal() {
            return (this.filteredEventParticipantRows || []).length;
        },
        /** 活动参与人当前页。创建于 2026-10-20 */
        pagedEventParticipantRows() {
            const list = this.filteredEventParticipantRows || [];
            const size = this.eventParticipantPageSize || 20;
            const page = this.eventParticipantPage || 1;
            const start = (page - 1) * size;
            return list.slice(start, start + size);
        },
        /** 弹窗中过滤后的管理员列表。最后更新：2026-09-08 */
        filteredAdminDialogList() {
            const list = this.adminDialogList || [];
            const key = (this.adminDialogFilterKey || '').trim().toLowerCase();
            if (!key) {
                return list.map(name => ({ name }));
            }
            return list
                .filter(name => String(name).toLowerCase().includes(key))
                .map(name => ({ name }));
        },
        /** 管理员详情弹窗总数文案：全体/单人直接说明，多人显示人数。最后更新：2026-10-19 */
        adminDialogTotalText() {
            const list = this.adminDialogList || [];
            if (list.length === 1) {
                return String(list[0]);
            }
            return `${list.length} 名管理员`;
        },
        /** 指导老师下拉源（由 GetEventManagerCandidates 按组织管理员范围返回，无需前端再筛） */
        eventManagerOptions() {
            const teachers = Array.isArray(this.eventFormTeacherMasterList) ? this.eventFormTeacherMasterList : [];
            return teachers;
        },
        /** 指导老师扁选项（供受限名单弹窗） */
        eventManagerFlatOptions() {
            return (this.eventManagerOptions || []).map(t => ({
                value: String(t.Id),
                label: t.TeacherName || String(t.Id)
            }));
        },
        /** 指导老师维护者下拉源：仅允许从已选指导老师中选择。 */
        eventManagerSetterOptions() {
            const managerOptions = this.eventManagerOptions;
            const selectedManagerIds = new Set(
                (this.eventForm && Array.isArray(this.eventForm.ManagerTeacherUserIds) ? this.eventForm.ManagerTeacherUserIds : [])
                    .map(x => String(x))
            );
            if (!managerOptions.length || !selectedManagerIds.size) return [];
            return managerOptions.filter(t => selectedManagerIds.has(String(t.Id)));
        },
        eventManagerSetterFlatOptions() {
            return (this.eventManagerSetterOptions || []).map(t => ({
                value: String(t.Id),
                label: t.TeacherName || String(t.Id)
            }));
        },
        orgAdminSelectedPreview() {
            return (this.orgAdminSelectedItems || []).slice(0, 8);
        },
        orgMemberSelectedPreview() {
            return (this.orgMemberSelectedItems || []).slice(0, 8);
        },
        eventParticipantOptions() {
            return (this.currentOrgMembers || []).map(m => {
                if (typeof m === 'string') return { value: m, label: m };
                return { value: String(m.Id), label: m.Name || String(m.Id) };
            });
        },
        eventParticipantSelectedCount() {
            return Array.isArray(this.eventForm.ParticipantUserIds) ? this.eventForm.ParticipantUserIds.length : 0;
        },
        eventParticipantSelectedPreview() {
            const idSet = new Set((this.eventForm.ParticipantUserIds || []).map(x => String(x)));
            return this.eventParticipantOptions.filter(o => idSet.has(String(o.value))).slice(0, 8);
        },
        eventManagerSelectedCount() {
            return Array.isArray(this.eventForm.ManagerTeacherUserIds) ? this.eventForm.ManagerTeacherUserIds.length : 0;
        },
        eventManagerSelectedPreview() {
            const idSet = new Set((this.eventForm.ManagerTeacherUserIds || []).map(x => String(x)));
            return this.eventManagerFlatOptions.filter(o => idSet.has(String(o.value))).slice(0, 8);
        },
        eventManagerSetterSelectedCount() {
            return Array.isArray(this.eventForm.ManagerSetterTeacherUserIds) ? this.eventForm.ManagerSetterTeacherUserIds.length : 0;
        },
        eventManagerSetterSelectedPreview() {
            const idSet = new Set((this.eventForm.ManagerSetterTeacherUserIds || []).map(x => String(x)));
            return this.eventManagerSetterFlatOptions.filter(o => idSet.has(String(o.value))).slice(0, 8);
        },
        eventDateRange: {
            get() {
                // 如果没有开始/结束时间，返回空数组（Element UI 的 date-picker 会正确显示为空），
                // 避免返回 [null, null] 导致组件显示 1970 年时间戳
                if (!this.eventForm) return [];
                const s = this.eventForm.StartDate;
                const e = this.eventForm.EndDate;
                if (!s && !e) return [];
                return [s || null, e || null];
            },
            set(val) {
                if (Array.isArray(val)) {
                    this.eventForm.StartDate = val[0] || null;
                    this.eventForm.EndDate = val[1] || null;
                } else {
                    this.eventForm.StartDate = null;
                    this.eventForm.EndDate = null;
                }
            }
        },
        /** 明细弹窗内全部场次行 */
        studentEventSessionRows() {
            if (!this.studentEventDetailRow) return [];
            return this.getStudentEventSessionRows(this.studentEventDetailRow);
        },
        /** 明细弹窗内当前页场次行 */
        pagedStudentEventSessionRows() {
            const list = this.studentEventSessionRows;
            const page = this.studentEventSessionPage || 1;
            const size = this.studentEventSessionPageSize || 10;
            const start = (page - 1) * size;
            return list.slice(start, start + size);
        },
        /** 明细弹窗：统一时段+按日期范围时只显示摘要 */
        studentEventDetailUseUnifiedSummary() {
            if (!this.studentEventDetailRow) return false;
            return this.shouldExpandUnifiedDateRangeSessions(this.studentEventDetailRow);
        },
        /** 统一时段摘要文案 */
        studentEventDetailUnifiedSummary() {
            if (!this.studentEventDetailRow) return '';
            return this.buildUnifiedSessionSummary(this.studentEventDetailRow);
        },
        /** 统一时段活动天数 */
        studentEventUnifiedDayCount() {
            if (!this.studentEventDetailRow) return 0;
            return this.expandUnifiedDateRangeSessions(this.studentEventDetailRow).length;
        }
    },
    methods: {
        /** 兼容后端可能返回的 bool/number/string 布尔值 */
        toBool(val) {
            if (val === true || val === 1) return true;
            if (typeof val === 'string') {
                const v = val.trim().toLowerCase();
                return v === 'true' || v === '1' || v === 'yes';
            }
            return false;
        },
        /** 解析管理员名字字符串为数组，用于标签展示 */
        getAdminNamesList(adminNames) {
            if (!adminNames) return [];
            return String(adminNames).split(',').map(s => s.trim()).filter(Boolean);
        },
        /**
         * 列表「管理员」列文案：全体或仅 1 人直接显示名称，多人显示数量。
         * 最后更新：2026-10-19
         */
        formatAdminListCellText(adminNames) {
            const list = this.getAdminNamesList(adminNames);
            if (!list.length) return '';
            if (list.length === 1) return list[0];
            return `已设 ${list.length} 名管理员`;
        },
        /** 解析行数据中的成员名称列表（带缓存，避免列表反复拆分超长字符串）。最后更新：2026-09-22 */
        getMemberNamesList(row) {
            if (!row) return [];
            if (Array.isArray(row._memberNamesCache)) return row._memberNamesCache;
            let list = [];
            if (row.MemberUserNames) {
                if (typeof row.MemberUserNames === 'string') {
                    list = row.MemberUserNames.split(/[,，、;；]/).map(s => s.trim()).filter(Boolean);
                } else if (Array.isArray(row.MemberUserNames)) {
                    list = row.MemberUserNames.map(x => (typeof x === 'string' ? x : (x.Name || x.RealName || ''))).filter(Boolean);
                }
            } else {
                const arr = row.Members || row.MemberList || row.MemberUsers || row.MembersList || row.MemberUserList || row.Users || row.MemberInfos;
                if (Array.isArray(arr)) {
                    list = arr.map(m => (m && (m.Name || m.RealName || m.TeacherName || m.StudentName || m.UserName || m.DisplayName)) || '').filter(Boolean);
                }
            }
            this.$set(row, '_memberNamesCache', list);
            if (row.MemberCount == null) this.$set(row, 'MemberCount', list.length);
            return list;
        },
        /** 仅取成员数量，优先用缓存/近似计数，避免列表渲染时反复拆串。创建于 2026-09-22 */
        getMemberCount(row) {
            if (!row) return 0;
            if (typeof row.MemberCount === 'number' && row.MemberCount >= 0) return row.MemberCount;
            if (Array.isArray(row._memberNamesCache)) return row._memberNamesCache.length;
            if (Array.isArray(row.MemberUserIds) && row.MemberUserIds.length) {
                row.MemberCount = row.MemberUserIds.length;
                return row.MemberCount;
            }
            if (typeof row.MemberUserNames === 'string' && row.MemberUserNames) {
                // 近似计数：按分隔符切分长度，不做 trim 过滤（打开弹窗时再精确拆）
                const approx = row.MemberUserNames.split(/[,，、;；]/).filter(s => s && s.trim()).length;
                row.MemberCount = approx;
                return approx;
            }
            return this.getMemberNamesList(row).length;
        },
        /** 从活动行数据解析指导老师 Id 列表（兼容 ManagerTeacherUserIds / ManagerTeacherIds） */
        normalizeEventManagerIdsFromRow(row) {
            if (!row) return [];
            let arr = row.ManagerTeacherUserIds;
            if (Array.isArray(arr) && arr.length) {
                return arr.map(x => (x != null && x !== '' ? x : null)).filter(v => v != null);
            }
            if (row.ManagerTeacherIds && typeof row.ManagerTeacherIds === 'string') {
                return row.ManagerTeacherIds.split(',').map(s => s.trim()).filter(Boolean);
            }
            return [];
        },
        /** 从活动行数据解析指导老师维护者 Id 列表 */
        normalizeEventManagerSetterIdsFromRow(row) {
            if (!row) return [];
            let arr = row.ManagerSetterTeacherUserIds;
            if (Array.isArray(arr) && arr.length) {
                return arr.map(x => (x != null && x !== '' ? x : null)).filter(v => v != null);
            }
            if (row.ManagerSetterTeacherIds && typeof row.ManagerSetterTeacherIds === 'string') {
                return row.ManagerSetterTeacherIds.split(',').map(s => s.trim()).filter(Boolean);
            }
            return [];
        },
        /** 加载当前组织可担任指导老师的教师主档（与组织管理员/全体教职工配置一致） */
        loadEventFormTeacherList() {
            const org = this.currentOrgForEvents || {};
            const orgId = org.Id;
            if (!orgId) {
                this.eventFormTeacherMasterList = [];
                return;
            }
            getEventManagerCandidates({ organizationId: orgId }).then((res) => {
                let list = [];
                const dto = res && res.data && res.data.response;
                if (dto) {
                    const arr = dto.Teachers != null ? dto.Teachers : dto.teachers;
                    if (Array.isArray(arr)) list = arr;
                }
                this.eventFormTeacherMasterList = list;
                this.sanitizeEventManagerSelections();
            }).catch(() => { this.eventFormTeacherMasterList = []; });
        },
        /** 加载当前组织校区可用的活动专业组类型（仅启用，供活动表单/筛选） */
        loadProfessionalGroupTypes() {
            const org = this.currentOrgForEvents || {};
            const campusId = org.CampusId;
            if (!campusId || campusId === '0') {
                this.professionalGroupTypes = [];
                return;
            }
            getProfessionalGroupTypes({ campusId: campusId }).then((res) => {
                const list = res && res.data && res.data.response;
                this.professionalGroupTypes = Array.isArray(list) ? list : [];
            }).catch(() => { this.professionalGroupTypes = []; });
        },
        /** 加载专业组维护列表（含停用，按校区）。最后更新：2026-10-19 */
        loadProfessionalGroupManageList() {
            const campusId = this.professionalGroupCampusId;
            if (!campusId || campusId === '0') {
                this.professionalGroupManageList = [];
                return;
            }
            this.professionalGroupLoading = true;
            getProfessionalGroupTypes({ campusId: campusId, includeDisabled: true }).then((res) => {
                const list = res && res.data && res.data.response;
                this.professionalGroupManageList = Array.isArray(list) ? list : [];
                const maxPage = Math.max(1, Math.ceil(this.filteredProfessionalGroupTotal / this.professionalGroupPageSize));
                if (this.professionalGroupPage > maxPage) this.professionalGroupPage = maxPage;
            }).catch(() => {
                this.professionalGroupManageList = [];
            }).finally(() => {
                this.professionalGroupLoading = false;
                this.$nextTick(() => this.relayoutProfessionalGroupTable());
            });
        },
        /** 弹窗打开后按实际高度重算表格。最后更新：2026-10-19 */
        handleProfessionalGroupDialogOpened() {
            this.$nextTick(() => this.relayoutProfessionalGroupTable());
        },
        relayoutProfessionalGroupTable() {
            const table = this.$refs.professionalGroupTable;
            if (table && typeof table.doLayout === 'function') {
                table.doLayout();
            }
        },
        openProfessionalGroupDialog() {
            if (!this.DepartmentId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            this.professionalGroupKeyword = '';
            this.professionalGroupStatusFilter = '';
            this.professionalGroupPage = 1;
            this.professionalGroupDialogVisible = true;
            const resolveCampusAndLoad = () => {
                const filterCampusId = this.filters && this.filters.campusId;
                const rowCampusId = (this.currentRow && this.currentRow.CampusId) || null;
                const firstCampusId = this.campusOptions.length ? this.campusOptions[0].Id : null;
                this.professionalGroupCampusId = filterCampusId || rowCampusId || this.professionalGroupCampusId || firstCampusId || null;
                this.loadProfessionalGroupManageList();
            };
            if (this.campusOptions && this.campusOptions.length) {
                resolveCampusAndLoad();
                return;
            }
            this.loadCampusOptions(this.DepartmentId).then(() => {
                resolveCampusAndLoad();
            });
        },
        handleProfessionalGroupCampusChange() {
            this.professionalGroupKeyword = '';
            this.professionalGroupStatusFilter = '';
            this.professionalGroupPage = 1;
            this.loadProfessionalGroupManageList();
        },
        handleProfessionalGroupFilterChange() {
            this.professionalGroupPage = 1;
        },
        handleProfessionalGroupPageChange(page) {
            this.professionalGroupPage = page || 1;
        },
        professionalGroupIndexMethod(index) {
            return (this.professionalGroupPage - 1) * this.professionalGroupPageSize + index + 1;
        },
        openProfessionalGroupForm(row) {
            const campusId = this.professionalGroupCampusId || 0;
            if (!campusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            this.professionalGroupForm = row
                ? { Id: row.Id, Name: row.Name || '', Sort: row.Sort || 0, Enabled: row.Enabled !== false, CampusId: campusId }
                : { Id: 0, Name: '', Sort: 0, Enabled: true, CampusId: campusId };
            this.professionalGroupFormVisible = true;
        },
        saveProfessionalGroup() {
            if (!this.professionalGroupCampusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            if (!this.professionalGroupForm.Name) {
                this.$message.warning('请输入专业组名称');
                return;
            }
            this.professionalGroupForm.CampusId = this.professionalGroupCampusId;
            const form = { ...this.professionalGroupForm };
            const request = form.Id ? updateProfessionalGroupType(form) : addProfessionalGroupType(form);
            this.professionalGroupSaving = true;
            request.then((res) => {
                if (res && res.data && res.data.success) {
                    this.$message.success('保存成功');
                    this.professionalGroupFormVisible = false;
                    this.loadProfessionalGroupManageList();
                    this.loadProfessionalGroupTypes();
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                }
            }).catch(() => this.$message.error('保存失败'))
                .finally(() => { this.professionalGroupSaving = false; });
        },
        removeProfessionalGroup(row) {
            const name = (row && row.Name) ? `「${row.Name}」` : '该专业组';
            this.$confirm(`确定删除专业组${name}吗？删除后不可恢复。`, '删除确认', {
                type: 'warning',
                confirmButtonText: '确定删除',
                cancelButtonText: '取消',
                confirmButtonClass: 'el-button--danger'
            }).then(() => {
                deleteProfessionalGroupType({ id: row.Id }).then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message.success('删除成功');
                        this.loadProfessionalGroupManageList();
                        this.loadProfessionalGroupTypes();
                    } else {
                        this.$message.error((res && res.data && res.data.msg) || '删除失败');
                    }
                }).catch(() => this.$message.error('删除失败'));
            }).catch(() => {});
        },
        /** 列表内快捷切换专业组启用状态（需确认）。最后更新：2026-10-19 */
        toggleProfessionalGroupEnabled(row, enabled) {
            if (!row || !row.Id) return;
            const previous = !enabled;
            const name = row.Name ? `「${row.Name}」` : '该专业组';
            const actionText = enabled ? '启用' : '停用';
            this.$confirm(`确定${actionText}专业组${name}吗？`, '状态确认', {
                type: 'warning',
                confirmButtonText: `确定${actionText}`,
                cancelButtonText: '取消',
                // 停用用红色强调风险，启用保持主色。最后更新：2026-10-19
                confirmButtonClass: enabled ? 'el-button--primary' : 'el-button--danger'
            }).then(() => {
                this.$set(row, '_statusSaving', true);
                updateProfessionalGroupType({
                    Id: row.Id,
                    Name: row.Name,
                    Sort: row.Sort || 0,
                    Enabled: enabled,
                    CampusId: this.professionalGroupCampusId || row.CampusId
                }).then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message.success(enabled ? '已启用' : '已停用');
                        this.loadProfessionalGroupTypes();
                    } else {
                        this.$set(row, 'Enabled', previous);
                        this.$message.error((res && res.data && res.data.msg) || '状态更新失败');
                    }
                }).catch(() => {
                    this.$set(row, 'Enabled', previous);
                    this.$message.error('状态更新失败');
                }).finally(() => {
                    this.$set(row, '_statusSaving', false);
                });
            }).catch(() => {
                // 取消时还原开关（el-switch 已先改成目标值）
                this.$set(row, 'Enabled', previous);
            });
        },
        /** 对指导老师、指导老师维护者执行下拉源约束，移除无效已选值 */
        sanitizeEventManagerSelections() {
            if (!this.eventForm) return;
            const managerOptionIdSet = new Set(this.eventManagerOptions.map(t => String(t.Id)));
            const setterOptionIdSet = new Set(this.eventManagerSetterOptions.map(t => String(t.Id)));
            const managerIds = Array.isArray(this.eventForm.ManagerTeacherUserIds) ? this.eventForm.ManagerTeacherUserIds : [];
            const setterIds = Array.isArray(this.eventForm.ManagerSetterTeacherUserIds) ? this.eventForm.ManagerSetterTeacherUserIds : [];
            const nextManagerIds = managerIds.map(x => String(x)).filter(id => managerOptionIdSet.has(id));
            const nextSetterIds = setterIds.map(x => String(x)).filter(id => setterOptionIdSet.has(id));
            if (JSON.stringify(managerIds.map(x => String(x))) !== JSON.stringify(nextManagerIds)) {
                this.eventForm.ManagerTeacherUserIds = nextManagerIds;
            }
            if (JSON.stringify(setterIds.map(x => String(x))) !== JSON.stringify(nextSetterIds)) {
                this.eventForm.ManagerSetterTeacherUserIds = nextSetterIds;
            }
        },
        dialogCheck(selection, row) {
            this.currentRow = null;
            this.$refs.table.clearSelection();
            if (selection.length === 0) {
                return;
            }
            if (row) {
                this.selectCurrentRow(row);
            }
        },
        selectCurrentRow(val) {
            if (val) {
                this.currentRow = val;
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(val, true);
            }
        },
        openEventOverviewPermissionDialog() {
            if (!this.DepartmentId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            this.eventOverviewPermissionForm.SchoolId = this.DepartmentId;
            this.overviewViewSelectedItems = [];
            this.overviewMaintainSelectedItems = [];
            this.overviewDeleteSelectedItems = [];
            this.captureOverviewPermissionBaseline();
            const resolveCampusAndLoad = () => {
                const filterCampusId = this.filters && this.filters.campusId;
                const rowCampusId = (this.currentRow && this.currentRow.CampusId) || null;
                const firstCampusId = this.campusOptions.length ? this.campusOptions[0].Id : null;
                this.eventOverviewPermissionForm.CampusId = filterCampusId || rowCampusId
                    || this.eventOverviewPermissionForm.CampusId || firstCampusId || null;
                this.eventOverviewPermissionDialogVisible = true;
                this.loadEventOverviewPermissions();
            };
            if (this.campusOptions && this.campusOptions.length) {
                resolveCampusAndLoad();
                return;
            }
            this.loadCampusOptions(this.DepartmentId).then(() => resolveCampusAndLoad());
        },
        loadEventOverviewPermissions() {
            if (!this.DepartmentId || !this.eventOverviewPermissionForm.CampusId) {
                this.overviewViewSelectedItems = [];
                this.overviewMaintainSelectedItems = [];
                this.overviewDeleteSelectedItems = [];
                this.captureOverviewPermissionBaseline();
                return;
            }
            getEventOverviewPermissions({
                schoolId: this.DepartmentId,
                campusId: this.eventOverviewPermissionForm.CampusId
            }).then((res) => {
                const data = res && res.data && res.data.response;
                if (data) {
                    this.eventOverviewPermissionForm = {
                        ...this.eventOverviewPermissionForm,
                        ...data,
                        CampusId: this.eventOverviewPermissionForm.CampusId
                    };
                    this.overviewViewSelectedItems = this.parseOverviewTeacherItems(
                        data.ViewTeachers || data.viewTeachers,
                        data.ViewTeacherMasterIds
                    );
                    this.overviewMaintainSelectedItems = this.parseOverviewTeacherItems(
                        data.MaintainTeachers || data.maintainTeachers,
                        data.MaintainTeacherMasterIds
                    );
                    this.overviewDeleteSelectedItems = this.parseOverviewTeacherItems(
                        data.DeleteTeachers || data.deleteTeachers,
                        data.DeleteTeacherMasterIds
                    );
                } else {
                    this.overviewViewSelectedItems = [];
                    this.overviewMaintainSelectedItems = [];
                    this.overviewDeleteSelectedItems = [];
                }
                this.captureOverviewPermissionBaseline();
            }).catch(() => {
                this.$message.error('获取总览权限失败');
                this.captureOverviewPermissionBaseline();
            });
        },
        handleOverviewCampusChange() {
            this.overviewViewSelectedItems = [];
            this.overviewMaintainSelectedItems = [];
            this.overviewDeleteSelectedItems = [];
            this.captureOverviewPermissionBaseline();
            this.loadEventOverviewPermissions();
        },
        /** 生成总览权限人员快照（仅比较 Id 集合）。最后更新：2026-10-19 */
        buildOverviewPermissionSnapshot() {
            const normalize = (list) => (list || []).map(x => String(x.id)).filter(Boolean).sort().join(',');
            return [
                normalize(this.overviewViewSelectedItems),
                normalize(this.overviewMaintainSelectedItems),
                normalize(this.overviewDeleteSelectedItems)
            ].join('|');
        },
        captureOverviewPermissionBaseline() {
            this.overviewPermissionBaseline = this.buildOverviewPermissionSnapshot();
        },
        /**
         * 解析总览权限已选教师：优先使用后端回传的姓名明细，兼容旧版仅 Id 字符串。
         */
        parseOverviewTeacherItems(teachers, idText) {
            if (Array.isArray(teachers) && teachers.length) {
                return teachers.map(t => ({
                    id: String(t.Id != null ? t.Id : t.id),
                    name: t.TeacherName || t.teacherName || String(t.Id != null ? t.Id : t.id),
                    personType: 'teacher'
                })).filter(x => x.id);
            }
            return String(idText || '').split(',').map(x => x.trim()).filter(Boolean).map(id => ({
                id, name: id, personType: 'teacher'
            }));
        },
        openOverviewTeacherPicker(role) {
            if (!this.eventOverviewPermissionForm.CampusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            this.overviewPickerRole = role;
            this.overviewPickerItems = role === 'maintain'
                ? this.overviewMaintainSelectedItems
                : (role === 'delete' ? this.overviewDeleteSelectedItems : this.overviewViewSelectedItems);
            this.overviewTeacherPickerVisible = true;
        },
        onOverviewTeachersPicked(people) {
            const items = (people || []).map(p => ({
                id: String(p.id),
                name: p.name || String(p.id),
                personType: 'teacher',
                deptId: p.deptId != null ? String(p.deptId) : ''
            }));
            if (this.overviewPickerRole === 'maintain') this.overviewMaintainSelectedItems = items;
            else if (this.overviewPickerRole === 'delete') this.overviewDeleteSelectedItems = items;
            else this.overviewViewSelectedItems = items;
            this.overviewTeacherPickerVisible = false;
        },
        clearOverviewTeachers(role) {
            if (role === 'maintain') this.overviewMaintainSelectedItems = [];
            else if (role === 'delete') this.overviewDeleteSelectedItems = [];
            else this.overviewViewSelectedItems = [];
        },
        removeOverviewTeacher(role, id) {
            const key = String(id);
            const filterItems = (list) => (list || []).filter(x => String(x.id) !== key);
            if (role === 'maintain') this.overviewMaintainSelectedItems = filterItems(this.overviewMaintainSelectedItems);
            else if (role === 'delete') this.overviewDeleteSelectedItems = filterItems(this.overviewDeleteSelectedItems);
            else this.overviewViewSelectedItems = filterItems(this.overviewViewSelectedItems);
        },
        saveEventOverviewPermissions() {
            if (!this.eventOverviewPermissionForm.CampusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            this.eventOverviewPermissionForm.SchoolId = this.DepartmentId;
            this.eventOverviewPermissionForm.ViewTeacherMasterIds = this.overviewViewSelectedItems.map(x => x.id).join(',');
            this.eventOverviewPermissionForm.MaintainTeacherMasterIds = this.overviewMaintainSelectedItems.map(x => x.id).join(',');
            this.eventOverviewPermissionForm.DeleteTeacherMasterIds = this.overviewDeleteSelectedItems.map(x => x.id).join(',');
            this.eventOverviewPermissionSaving = true;
            updateEventOverviewPermissions(this.eventOverviewPermissionForm).then((res) => {
                if (res && res.data && res.data.success) {
                    this.$message.success('保存成功');
                    this.captureOverviewPermissionBaseline();
                    this.eventOverviewPermissionDialogVisible = false;
                } else {
                    this.$message.error((res && res.data && res.data.msg) || '保存失败');
                }
            }).catch(() => this.$message.error('保存失败'))
                .finally(() => { this.eventOverviewPermissionSaving = false; });
        },

        /** 组装活动事件导出公共参数（与列表筛选一致）。创建于 2026-10-28 */
        buildEventExportParams() {
            return {
                organizationId: (this.currentOrgForEvents && this.currentOrgForEvents.Id)
                    || (this.currentRow && this.currentRow.Id)
                    || 0,
                status: this.eventsStatus || '',
                professionalGroupTypeId: this.eventsProfessionalGroupTypeId || 0,
                keyword: this.eventsKeyword || '',
                startDate: this.eventsDateRange && this.eventsDateRange[0] || '',
                endDate: this.eventsDateRange && this.eventsDateRange[1] || ''
            };
        },
        /** 当前组织名，用于导出文件名。创建于 2026-10-28 */
        getEventExportOrgName() {
            return ((this.currentOrgForEvents && this.currentOrgForEvents.Name)
                || (this.currentRow && this.currentRow.Name)
                || '').toString().trim().replace(/[\\/:*?"<>|]/g, '_');
        },
        /** 下载 blob Excel。创建于 2026-10-28 */
        downloadExcelBlob(data, fileNameWithoutExt) {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileNameWithoutExt + '.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        /** 活动事件弹窗是否已绑定组织（点「活动事件」只写 currentOrgForEvents，不保证选中 currentRow）。最后更新：2026-10-28 */
        ensureEventOrgSelected() {
            const orgId = (this.currentOrgForEvents && this.currentOrgForEvents.Id)
                || (this.currentRow && this.currentRow.Id)
                || 0;
            if (!orgId) {
                this.$message({
                    message: "请先选择一个组织",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        async exportExcel() {
            try {
                if (!this.ensureEventOrgSelected()) return;

                const para = this.buildEventExportParams();
                // 文件名带上当前组织名称。最后更新：2026-10-28
                const orgName = this.getEventExportOrgName();
                const fileName = orgName ? `${orgName}-活动明细表` : '活动明细表';

                const response = await exportEventsExcel(para);
                if (!response.data) {
                    this.$message({
                        message: "导出数据为空",
                        type: "error",
                    });
                    return;
                }

                this.downloadExcelBlob(response.data, fileName);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message({
                    message: "导出失败",
                    type: "error",
                });
            }
        },
        /** 按学生竞赛表格模板导出（独立按钮）。创建于 2026-10-28 */
        async exportCompetitionExcel() {
            try {
                if (!this.ensureEventOrgSelected()) return;

                const para = this.buildEventExportParams();
                const orgName = this.getEventExportOrgName();
                const fileName = orgName ? `${orgName}-学生竞赛导出表` : '学生竞赛导出表';

                this.exportLoading = true;
                const response = await exportCompetitionEventsExcel(para);
                if (!response.data) {
                    this.$message({
                        message: "导出数据为空",
                        type: "error",
                    });
                    return;
                }

                this.downloadExcelBlob(response.data, fileName);
            } catch (error) {
                console.error('竞赛表下载失败:', error);
                this.$message({
                    message: "导出竞赛表格失败",
                    type: "error",
                });
            } finally {
                this.exportLoading = false;
            }
        },

        // 活动时间校验器（用于 el-form 校验）
        validateEventDate(rule, value, callback) {
            const range = this.eventDateRange;
            if (!Array.isArray(range) || range.length !== 2 || !range[0] || !range[1]) {
                callback(new Error('请选择活动开始和结束日期'));
            } else {
                callback();
            }
        },
        formatDateOnly(v) {
            if (!v) return '';
            try {
                const d = new Date(v);
                const y = d.getFullYear();
                const m = (d.getMonth() + 1).toString().padStart(2, '0');
                const day = d.getDate().toString().padStart(2, '0');
                return `${y}-${m}-${day}`;
            } catch (e) { return v; }
        },
        /** 格式化为 yyyy-MM-dd HH:mm:ss */
        formatDateTime(v) {
            if (!v) return '';
            try {
                const d = new Date(v);
                const y = d.getFullYear();
                const m = (d.getMonth() + 1).toString().padStart(2, '0');
                const day = d.getDate().toString().padStart(2, '0');
                const h = d.getHours().toString().padStart(2, '0');
                const min = d.getMinutes().toString().padStart(2, '0');
                const sec = d.getSeconds().toString().padStart(2, '0');
                return `${y}-${m}-${day} ${h}:${min}:${sec}`;
            } catch (e) { return v; }
        },
        // 根据 StartDate/EndDate 生成周次选项
        buildWeekOptionsFromRange() {
            this.weekOptions = [];
            this.eventForm.WeekNumbers = this.eventForm.WeekNumbers || [];
            const s = this.eventForm.StartDate ? new Date(this.eventForm.StartDate) : null;
            const e = this.eventForm.EndDate ? new Date(this.eventForm.EndDate) : null;
            if (!s || !e) return;
            // 计算从开始到结束有多少周（以周一为周起点），并列出每周的起止日期
            // 找到 start 周的周一
            const start = new Date(s.getFullYear(), s.getMonth(), s.getDate());
            const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());
            // ISO 周一: getDay() 1..7 (0->Sunday)
            function toMonday(dt) {
                const d = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
                const day = d.getDay();
                const diff = (day === 0 ? -6 : 1) - day; // move to Monday
                d.setDate(d.getDate() + diff);
                return d;
            }
            let curMon = toMonday(start);
            let idx = 1;
            while (curMon <= end) {
                const weekStart = new Date(curMon.getFullYear(), curMon.getMonth(), curMon.getDate());
                const weekEnd = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate());
                weekEnd.setDate(weekEnd.getDate() + 6);
                // clamp weekEnd to overall end
                const realEnd = weekEnd > end ? end : weekEnd;
                const label = `第${idx}周 (${this.formatDateOnly(weekStart)} ~ ${this.formatDateOnly(realEnd)})`;
                this.weekOptions.push({ value: idx, label: label, start: this.formatDateOnly(weekStart), end: this.formatDateOnly(realEnd) });
                idx++;
                curMon.setDate(curMon.getDate() + 7);
            }
        },
        // 根据当前 eventForm.StartDate/EndDate 构建 dateSessions
        buildDateSessionsFromRange() {
            this.dateSessions = [];
            this.datePage = 1;
            const s = this.eventForm.StartDate ? new Date(this.eventForm.StartDate) : null;
            const e = this.eventForm.EndDate ? new Date(this.eventForm.EndDate) : null;
            if (!s || !e) return;
            // normalize time to midnight for iteration
            let cur = new Date(s.getFullYear(), s.getMonth(), s.getDate());
            const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());
            const existing = Array.isArray(this.eventForm.Sessions) ? this.eventForm.Sessions : [];
            while (cur <= end) {
                const key = this.formatDateOnly(cur);
                const ex = existing.find(x => x.SpecificDate || x.specificDate ? this.formatDateOnly(x.SpecificDate || x.specificDate) === key : false);
                this.dateSessions.push({ date: key, startTime: ex ? (ex.StartTime || ex.startTime || null) : null, endTime: ex ? (ex.EndTime || ex.endTime || null) : null });
                cur.setDate(cur.getDate() + 1);
            }
        },
        // 每日时段分页数据
        pagedDateSessions() {
            const p = this.datePage || 1;
            const size = this.datePageSize || 5;
            const start = (p - 1) * size;
            return this.dateSessions.slice(start, start + size);
        },
        // 根据当前 StartDate/EndDate 计算范围内出现的星期集合（1..7），并禁用不在范围内的 weekdaySessions
        buildAvailableWeekdaysFromRange() {
            this.availableWeekdays = [];
            const s = this.eventForm.StartDate ? new Date(this.eventForm.StartDate) : null;
            const e = this.eventForm.EndDate ? new Date(this.eventForm.EndDate) : null;
            if (!s || !e) return;
            const set = new Set();
            let cur = new Date(s.getFullYear(), s.getMonth(), s.getDate());
            const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());
            while (cur <= end) {
                const day = cur.getDay(); // 0 (Sun) .. 6 (Sat)
                const wd = day === 0 ? 7 : day; // map to 1..7 (Mon=1..Sun=7)
                set.add(wd);
                cur.setDate(cur.getDate() + 1);
            }
            this.availableWeekdays = Array.from(set);
            // 清理不在可选范围的 weekdaySessions（禁用并清空时段）
            this.weekdaySessions.forEach(w => {
                if (this.availableWeekdays.length > 0 && !this.availableWeekdays.includes(w.weekday)) {
                    w.enabled = false;
                    w.startTime = null;
                    w.endTime = null;
                }
            });
        },
        // 将 weekdaySessions/dateSessions 收集到 eventForm.Sessions 中
        collectSessionsToForm() {
            const result = [];
            if (this.eventForm.IsUnifiedTimeSlot) {
                if (this.eventForm.ScheduleMode === 1) {
                    // 统一时段 + 按日期范围：按起止日期逐日生成，避免沿用旧的 dateSessions 缓存
                    const s = this.eventForm.StartDate ? new Date(this.eventForm.StartDate) : null;
                    const e = this.eventForm.EndDate ? new Date(this.eventForm.EndDate) : null;
                    if (s && e) {
                        let cur = new Date(s.getFullYear(), s.getMonth(), s.getDate());
                        const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());
                        while (cur <= end) {
                            result.push({
                                SpecificDate: this.formatDateOnly(cur),
                                StartTime: this.eventForm.UnifiedStartTime || null,
                                EndTime: this.eventForm.UnifiedEndTime || null
                            });
                            cur.setDate(cur.getDate() + 1);
                        }
                    }
                } else if (this.eventForm.ScheduleMode === 2) {
                    // 为每个启用的星期生成会话，使用统一时段
                    this.weekdaySessions.forEach(w => {
                        if (w.enabled) {
                            result.push({ Weekday: w.weekday, StartTime: this.eventForm.UnifiedStartTime || null, EndTime: this.eventForm.UnifiedEndTime || null });
                        }
                    });
                }
            } else {
                if (this.eventForm.ScheduleMode === 1) {
                    // dateSessions -> SpecificDate
                    this.dateSessions.forEach(ds => {
                        if (ds.startTime || ds.endTime) {
                            result.push({ SpecificDate: ds.date, StartTime: ds.startTime || null, EndTime: ds.endTime || null });
                        }
                    });
                } else if (this.eventForm.ScheduleMode === 2) {
                    this.weekdaySessions.forEach(w => {
                        if (w.enabled) {
                            result.push({ Weekday: w.weekday, StartTime: w.startTime || null, EndTime: w.endTime || null });
                        }
                    });
                }
            }
            this.eventForm.Sessions = result;
        },
        // parse time string "HH:mm:ss" or Date to seconds since 00:00
        parseTimeToSeconds(t) {
            if (t == null || t === '') return null;
            if (typeof t === 'string') {
                const parts = t.split(':').map(x => parseInt(x, 10));
                if (parts.length >= 2) {
                    const h = parts[0] || 0; const m = parts[1] || 0; const s = parts[2] || 0;
                    return h * 3600 + m * 60 + s;
                }
                return null;
            }
            if (t instanceof Date) return t.getHours() * 3600 + t.getMinutes() * 60 + t.getSeconds();
            return null;
        },
        // 同步校验统一时段：结束不能小于开始
        validateUnifiedTimesSync() {
            if (!this.eventForm.IsUnifiedTimeSlot) return { ok: true };
            const s = this.parseTimeToSeconds(this.eventForm.UnifiedStartTime);
            const e = this.parseTimeToSeconds(this.eventForm.UnifiedEndTime);
            if (s == null || e == null) return { ok: false, msg: '统一时段请填写开始和结束时刻' };
            if (e < s) return { ok: false, msg: '统一时段：结束时刻不能早于开始时刻' };
            return { ok: true };
        },
        // 校验非统一时段的各条时段是否合法
        validateSessionsSync() {
            // 按周次：只需选择星期并填写时段（不再强制选择周次下拉）
            if (this.eventForm.ScheduleMode === 2) {
                const enabledWeekdays = this.weekdaySessions.filter(x => x.enabled);
                if (!enabledWeekdays || enabledWeekdays.length === 0) return { ok: false, msg: '请至少选择一个星期并填写相应时段' };
                // 若使用统一时段，统一时段校验由 validateUnifiedTimesSync 处理（在 submit 中已先行调用）
                if (!this.eventForm.IsUnifiedTimeSlot) {
                    for (const w of enabledWeekdays) {
                        const s = this.parseTimeToSeconds(w.startTime);
                        const e = this.parseTimeToSeconds(w.endTime);
                        if ((s == null && e != null) || (s != null && e == null)) return { ok: false, msg: `${w.name} 的开始/结束时刻必须同时填写` };
                        if (s != null && e != null && e < s) return { ok: false, msg: `${w.name} 的结束时刻不能早于开始时刻` };
                    }
                }
            }
            // 按日期模式的校验
            if (this.eventForm.ScheduleMode === 1 && !this.eventForm.IsUnifiedTimeSlot) {
                for (const ds of this.dateSessions) {
                    const s = this.parseTimeToSeconds(ds.startTime);
                    const e = this.parseTimeToSeconds(ds.endTime);
                    if ((s == null && e != null) || (s != null && e == null)) return { ok: false, msg: `日期 ${ds.date} 的开始/结束时刻必须同时填写` };
                    if (s != null && e != null && e < s) return { ok: false, msg: `日期 ${ds.date} 的结束时刻不能早于开始时刻` };
                }
            }
            return { ok: true };
        },
        formatDate(v) { if (!v) return ''; try { return new Date(v).toLocaleString(); } catch (e) { return v; } },
        callFunction(item) {
            if (!item) return;
            if (typeof item.search === 'object') {
                this.filters = item.search;
            } else if (item.search) {
                this.filters = { key: item.search };
            } else {
                this.filters = {};
            }

            if (item.Func && typeof this[item.Func] === 'function') {
                this[item.Func].apply(this, item);
            } else {
                this.loadList();
            }
        },
        treeNodeClick(data) {
            const departmentId = data && data.value ? data.value : 0;
            this.DepartmentId = departmentId;
            this.loadCampusOptions(departmentId);
            this.loadList({ departmentId });
        },
        handleQuery() { this.loadList(); },
        orgTableRowClass({ row }) {
            return row.Level === 2 ? 'org-row-child' : '';
        },
        handleAdd() {
            // 限制：必须先在左侧选择具体的学校机构才能进行新增组织
            if (!this.DepartmentId || this.DepartmentId === '0' || this.DepartmentId === 0) {
                this.$message.warning("请先在左侧选择具体的学校机构！");
                return;
            }
            this.isAddSub = false;
            this.dialogTitle = '新增组织';
            // 初始化 editForm.DepartmentId 直接绑定为左侧选中的学校 ID
            this.editForm = { Id: 0, ParentId: 0, Name: '', ShortTag: '', Level: 1, Description: '', Dids: [], DepartmentId: this.DepartmentId, CampusId: null, AdminIdsArray: [], AllTeachersAsAdmins: false, MemberUserIds: [] };
            this.adminIdsDraftBeforeAllTeachers = [];
            this.adminItemsDraftBeforeAllTeachers = [];
            this.orgAdminSelectedItems = [];
            this.orgMemberSelectedItems = [];
            this.options = [];
            this.campusOptions = [];
            // 直接加载当前学校的校区，不需要再加载完整的机构树
            this.loadCampusOptions(this.editForm.DepartmentId);
            this.editFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
        },
        /** 操作列下拉菜单命令分发。最后更新：2025-03-19 */
        handleOpCommand(cmd, row) {
            if (!row) return;
            if (cmd === 'addSub') this.handleAddSub(row);
            else if (cmd === 'events') this.openEvents(row);
            else if (cmd === 'edit') this.handleEdit(row);
            else if (cmd === 'delete') this.handleDel(row);
        },
        handleAddSub(row) {
            this.isAddSub = true;
            this.dialogTitle = '新增子组织';
            const parentCampusId = row.CampusId && row.CampusId !== 0 ? row.CampusId : null;
            const parentDeptId = row.DepartmentId || 0;
            const parentDids = row.Dids && Array.isArray(row.Dids) ? [...row.Dids] : (parentDeptId ? [parentDeptId] : []);
            this.editForm = {
                Id: 0, ParentId: row.Id, Name: '', ShortTag: '', Level: (row.Level || 1) + 1, Description: '',
                Dids: parentDids, DepartmentId: parentDeptId, CampusId: parentCampusId, AdminIdsArray: [], AllTeachersAsAdmins: false, MemberUserIds: []
            };
            this.adminIdsDraftBeforeAllTeachers = [];
            this.adminItemsDraftBeforeAllTeachers = [];
            this.orgAdminSelectedItems = [];
            this.orgMemberSelectedItems = [];
            if (this.editForm.Level > 2) this.editForm.Level = 2;
            this.options = [];
            let para = { pid: 0, type: 1 };
            getSchoolDepartmentTree(para).then((res) => { ++this.isResouceShow; this.options.push(res.data.response); }).catch(() => { });
            this.loadCampusOptions(parentDeptId);
            this.editFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
        },
        handleEdit(row) {
            this.isAddSub = false;
            this.dialogTitle = '编辑组织';
            const rowAllTeachersAdm = this.toBool(row && row.AllTeachersAsAdmins) || this.toBool(row && row.allTeachersAsAdmins);
            if (row && !rowAllTeachersAdm && row.AdminIds)
                row.AdminIdsArray = (row.AdminIds && row.AdminIds.length) ? row.AdminIds.split(',').map(x => String(x)) : [];
            else if (row && rowAllTeachersAdm)
                row.AdminIdsArray = [];
            this.editForm = Object.assign({}, row);
            this.editForm.AllTeachersAsAdmins = rowAllTeachersAdm;
            this.adminIdsDraftBeforeAllTeachers = Array.isArray(this.editForm.AdminIdsArray) ? [...this.editForm.AdminIdsArray] : [];
            this.adminItemsDraftBeforeAllTeachers = [];
            if (this.editForm.AllTeachersAsAdmins)
                this.editForm.AdminIdsArray = [];
            if (this.editForm.ParentId === null || this.editForm.ParentId === undefined) this.editForm.ParentId = 0;
            if (this.editForm.CampusId === 0 || this.editForm.CampusId === '0') this.$set(this.editForm, 'CampusId', null);

            this.loadCampusOptions(this.editForm.DepartmentId);
            this.hydrateOrgAdminSelectedItems(row);
            this.hydrateOrgMemberSelectedItems(row);
            this.adminItemsDraftBeforeAllTeachers = (this.orgAdminSelectedItems || []).map(x => ({ ...x }));
            this.editFormVisible = true;
            this.$nextTick(() => {
                if (this.$refs.editForm) this.$refs.editForm.clearValidate();
            });
        },
        handleDel(row) {
            if (!row) return;
            this.$confirm('确认删除该组织吗?', '提示', { type: 'warning' }).then(() => {
                this.listLoading = true;
                deleteOrganization({ id: row.Id }).then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.loadList();
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                        this.listLoading = false;
                    }
                }).catch(() => { this.listLoading = false; });
            }).catch(() => { });
        },
        openEvents(row) {
            if (!row) return;
            this.currentOrgForEvents = row;
            this.eventDialogVisible = true;
            this.eventsPage = 1;
            this.eventsStatus = '';
            this.eventsProfessionalGroupTypeId = null;
            this.eventsKeyword = '';
            this.eventsDateRange = [];
            this.loadEvents({ organizationId: row.Id, page: 1 });
            // 清空成员，实际成员在新增/编辑活动时再加载
            this.currentOrgMembers = [];
            this.loadEventFormTeacherList();
            this.loadProfessionalGroupTypes();
        },
        /** 弹窗打开后按容器实测高度设置表格像素高。最后更新：2026-10-20 */
        onEventDialogOpened() {
            this.$nextTick(() => {
                this.relayoutEventListTable();
                setTimeout(() => this.relayoutEventListTable(), 100);
            });
        },
        /**
         * 用数字 height 铺满中间区域。
         * 说明：height="100%" 时 DOM 没有 height 属性，会被 dialog-theme 的
         * `.el-table:not([height]) .el-table__body-wrapper { max-height:420px }` 卡住。
         * 最后更新：2026-10-20
         */
        relayoutEventListTable() {
            const wrap = this.$refs.eventTableWrap;
            if (wrap && wrap.clientHeight > 0) {
                this.eventListTableHeight = Math.floor(wrap.clientHeight);
            }
            this.$nextTick(() => {
                const table = this.$refs.eventListTable;
                if (table && typeof table.doLayout === 'function') {
                    table.doLayout();
                }
            });
        },
        /** 打开按学生查询活动弹窗。最后更新：2026-09-23 */
        openStudentEventQueryDialog() {
            this.studentEventDialogVisible = true;
            this.studentEventQuery = { studentId: 0, studentName: '', keyword: '' };
            this.studentEvents = [];
            this.studentEventsTotal = 0;
            this.studentEventsPage = 1;
            this.selectedStudentName = '';
            this.studentEventDialogTitle = '按学生查询活动';
        },
        openStudentEventPicker() {
            if (!this.DepartmentId) {
                this.$message.warning('请先在左侧选择机构');
                return;
            }
            this.studentEventPickerVisible = true;
        },
        clearStudentEventPick() {
            this.studentEventQuery.studentId = 0;
            this.studentEventQuery.studentName = '';
            this.selectedStudentName = '';
            this.studentEventDialogTitle = '按学生查询活动';
        },
        onStudentEventPicked(person) {
            if (!person) return;
            this.studentEventQuery.studentId = person.id;
            this.studentEventQuery.studentName = person.name || '';
            this.selectedStudentName = person.name || '';
        },
        /** 查询学生参与的活动 */
        searchStudentEvents() {
            const studentId = Number(this.studentEventQuery.studentId) || 0;
            if (!studentId) {
                this.$message.warning('请先选择学生');
                return;
            }
            this.selectedStudentName = this.studentEventQuery.studentName || '';
            this.studentEventDialogTitle = this.selectedStudentName
                ? (`${this.selectedStudentName} - 参与活动`)
                : '按学生查询活动';
            this.studentEventsPage = 1;
            this.loadStudentEvents();
        },
        loadStudentEvents() {
            const studentId = Number(this.studentEventQuery.studentId) || 0;
            if (!studentId) return;
            this.studentEventsLoading = true;
            const para = {
                studentId,
                page: this.studentEventsPage,
                intPageSize: this.studentEventsPageSize,
                keyword: this.studentEventQuery.keyword || ''
            };
            getEventsByStudent(para).then((res) => {
                this.studentEventsLoading = false;
                if (!res || !res.data) {
                    this.studentEvents = [];
                    this.studentEventsTotal = 0;
                    return;
                }
                if (!res.data.success) {
                    this.$message.error(res.data.msg || '查询失败');
                    this.studentEvents = [];
                    this.studentEventsTotal = 0;
                    return;
                }
                let list = [];
                const r = res.data.response;
                if (r) {
                    if (Array.isArray(r.data)) list = r.data;
                    else if (Array.isArray(r)) list = r;
                    this.studentEventsTotal = r.dataCount || r.total || list.length || 0;
                    if (r.page) this.studentEventsPage = r.page;
                    else if (r.Page) this.studentEventsPage = r.Page;
                    if (r.PageSize) this.studentEventsPageSize = r.PageSize;
                }
                this.studentEvents = Array.isArray(list) ? list.map((it) => this.normalizeStudentEventRow(it)) : [];
                this.enrichStudentEventsWithSessions(this.studentEvents);
            }).catch(() => {
                this.studentEventsLoading = false;
                this.studentEvents = [];
                this.studentEventsTotal = 0;
            });
        },
        handleStudentEventsPageChange(page) {
            this.studentEventsPage = page;
            this.loadStudentEvents();
        },
        /** 打开学生活动明细弹窗 */
        showStudentEventDetail(row) {
            if (!row) return;
            const normalized = this.normalizeStudentEventRow(row);
            this.studentEventDetailRow = normalized;
            this.studentEventSessionPage = 1;
            this.studentEventDetailTitle = (normalized.Title || '活动') + ' - 明细';
            this.studentEventDetailVisible = true;
            if ((!normalized.Sessions || !normalized.Sessions.length) && !normalized.SessionSummary) {
                this.loadStudentEventDetailFromOrg(normalized);
            }
        },
        handleStudentEventSessionPageChange(page) {
            this.studentEventSessionPage = page;
        },
        /** 为学生活动列表补全场次/时段（复用 GetEvents 数据） */
        enrichStudentEventsWithSessions(rows) {
            if (!Array.isArray(rows) || !rows.length) return;
            const needEnrich = rows.filter((r) => r && (!r.Sessions || !r.Sessions.length) && !r.SessionSummary);
            if (!needEnrich.length) return;
            const orgIds = Array.from(new Set(needEnrich.map((r) => r.OrganizationId).filter(Boolean)));
            orgIds.forEach((orgId) => {
                getEvents({ organizationId: orgId, page: 1, intPageSize: 500 }).then((res) => {
                    let list = [];
                    if (res && res.data && res.data.response) {
                        const r = res.data.response;
                        if (Array.isArray(r.data)) list = r.data;
                        else if (Array.isArray(r)) list = r;
                    }
                    needEnrich.filter((row) => String(row.OrganizationId) === String(orgId)).forEach((row) => {
                        const target = (list || []).find((it) => String(it.Id) === String(row.EventId) || String(it.id) === String(row.EventId));
                        if (!target) return;
                        this.$set(row, 'Sessions', target.Sessions || target.sessions || []);
                        if (row.ScheduleMode == null) this.$set(row, 'ScheduleMode', target.ScheduleMode != null ? target.ScheduleMode : target.scheduleMode);
                        if (row.IsUnifiedTimeSlot == null) this.$set(row, 'IsUnifiedTimeSlot', target.IsUnifiedTimeSlot != null ? target.IsUnifiedTimeSlot : target.isUnifiedTimeSlot);
                        if (!row.UnifiedStartTime) this.$set(row, 'UnifiedStartTime', target.UnifiedStartTime || target.unifiedStartTime || null);
                        if (!row.UnifiedEndTime) this.$set(row, 'UnifiedEndTime', target.UnifiedEndTime || target.unifiedEndTime || null);
                        this.$set(row, 'SessionSummary', this.buildStudentEventSessionSummary(row));
                    });
                }).catch(() => { });
            });
        },
        /** 明细弹窗兜底：从组织活动列表拉取完整场次 */
        loadStudentEventDetailFromOrg(row) {
            const orgId = row.OrganizationId || row.organizationId;
            const eventId = row.EventId || row.eventId;
            if (!orgId || !eventId) return;
            getEvents({ organizationId: orgId, page: 1, intPageSize: 200 }).then((res) => {
                let list = [];
                if (res && res.data && res.data.response) {
                    const r = res.data.response;
                    if (Array.isArray(r.data)) list = r.data;
                    else if (Array.isArray(r)) list = r;
                }
                const target = (list || []).find((it) => String(it.Id) === String(eventId) || String(it.id) === String(eventId));
                if (!target) return;
                const merged = this.normalizeStudentEventRow(Object.assign({}, row, target, {
                    EventId: eventId,
                    OrganizationId: orgId,
                    Sessions: target.Sessions || target.sessions || []
                }));
                this.studentEventDetailRow = merged;
                this.studentEventSessionPage = 1;
            }).catch(() => { });
        },
        /** 归一化学生活动行数据（兼容 camelCase / PascalCase） */
        normalizeStudentEventRow(it) {
            if (!it) return it;
            const row = Object.assign({}, it);
            row.EventId = row.EventId != null ? row.EventId : row.eventId;
            row.OrganizationName = row.OrganizationName || row.organizationName || '';
            row.Title = row.Title || row.title || '';
            row.Location = row.Location || row.location || '';
            row.Description = row.Description || row.description || '';
            row.ManagerTeacherNames = row.ManagerTeacherNames || row.managerTeacherNames || '';
            row.StartDate = row.StartDate === 0 || row.StartDate === '0' || row.StartDate === '' ? null : (row.StartDate || row.startDate || null);
            row.EndDate = row.EndDate === 0 || row.EndDate === '0' || row.EndDate === '' ? null : (row.EndDate || row.endDate || null);
            row.CreateTime = row.CreateTime || row.createTime || null;
            row.ScheduleMode = row.ScheduleMode != null ? row.ScheduleMode : row.scheduleMode;
            row.IsUnifiedTimeSlot = row.IsUnifiedTimeSlot != null ? row.IsUnifiedTimeSlot : row.isUnifiedTimeSlot;
            row.UnifiedStartTime = row.UnifiedStartTime || row.unifiedStartTime || null;
            row.UnifiedEndTime = row.UnifiedEndTime || row.unifiedEndTime || null;
            row.Sessions = Array.isArray(row.Sessions) ? row.Sessions : (Array.isArray(row.sessions) ? row.sessions : []);
            row.SessionSummary = row.SessionSummary || row.sessionSummary || this.buildStudentEventSessionSummary(row);
            return row;
        },
        /** 前端兜底构建时段摘要（后端未升级时） */
        buildStudentEventSessionSummary(row) {
            if (!row) return '';
            if (this.shouldExpandUnifiedDateRangeSessions(row)) {
                return this.buildUnifiedSessionSummary(row);
            }
            const sessions = Array.isArray(row.Sessions) ? row.Sessions : [];
            const entries = [];
            sessions.forEach((s) => {
                const start = this.formatTimeOnly(s.StartTime || s.startTime);
                const end = this.formatTimeOnly(s.EndTime || s.endTime);
                const timePart = start + (end ? ('-' + end) : '');
                if (s.SpecificDate || s.specificDate) {
                    entries.push(`${this.formatDateOnly(s.SpecificDate || s.specificDate)} ${timePart}`.trim());
                } else if (s.Weekday != null || s.weekday != null) {
                    entries.push(`${this.weekdayToLabel(s.Weekday != null ? s.Weekday : s.weekday)} ${timePart}`.trim());
                }
            });
            if (entries.length) return entries.join('; ');
            return this.buildUnifiedSessionSummary(row);
        },
        /** 统一时段模式的摘要文案 */
        buildUnifiedSessionSummary(row) {
            if (!row) return '';
            const isUnified = row.IsUnifiedTimeSlot === true || row.IsUnifiedTimeSlot === 1;
            const uStart = this.formatTimeOnly(row.UnifiedStartTime);
            const uEnd = this.formatTimeOnly(row.UnifiedEndTime);
            if (!isUnified || (!uStart && !uEnd)) return '';
            const t = `${uStart}${uEnd ? ('-' + uEnd) : ''}`;
            const mode = row.ScheduleMode;
            if (mode === 1 && row.StartDate && row.EndDate) {
                const dayCount = this.expandUnifiedDateRangeSessions(row).length;
                return `每天 ${t} (${this.formatDateOnly(row.StartDate)}~${this.formatDateOnly(row.EndDate)}，共 ${dayCount} 天)`;
            }
            if (mode === 2) return `每周（指定星期） ${t}`;
            return `统一时段 ${t}`;
        },
        /** 按日期范围 + 统一时段展开每日场次 */
        expandUnifiedDateRangeSessions(row) {
            if (!row || !row.StartDate || !row.EndDate) return [];
            const uStart = this.formatTimeOnly(row.UnifiedStartTime);
            const uEnd = this.formatTimeOnly(row.UnifiedEndTime);
            const timeRange = uStart || uEnd ? `${uStart}${uEnd ? (' - ' + uEnd) : ''}` : '—';
            const rows = [];
            let cur = new Date(row.StartDate);
            const end = new Date(row.EndDate);
            cur = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate());
            const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
            while (cur <= endDay) {
                rows.push({ dateLabel: this.formatDateOnly(cur), timeRange });
                cur.setDate(cur.getDate() + 1);
            }
            return rows;
        },
        /** 是否应按日期范围展开统一时段（忽略库中零散场次） */
        shouldExpandUnifiedDateRangeSessions(row) {
            if (!row) return false;
            const isUnified = row.IsUnifiedTimeSlot === true || row.IsUnifiedTimeSlot === 1;
            return isUnified && row.ScheduleMode === 1 && row.StartDate && row.EndDate;
        },
        /** 调度模式文案 */
        mapScheduleModeLabel(mode) {
            if (mode === 1) return '按日期范围';
            if (mode === 2) return '按周次';
            return '未知';
        },
        /** 格式化时刻 HH:mm */
        formatTimeOnly(v) {
            if (v == null || v === '') return '';
            if (typeof v === 'string') {
                const parts = v.split(':');
                if (parts.length >= 2) return `${parts[0]}:${parts[1]}`;
            }
            return String(v);
        },
        /** 星期数字转中文 */
        weekdayToLabel(w) {
            const map = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 7: '周日' };
            return map[w] || String(w || '');
        },
        /** 将活动 Sessions 转为明细表格行 */
        getStudentEventSessionRows(row) {
            if (!row) return [];
            const normalized = this.normalizeStudentEventRow(row);
            // 统一时段 + 按日期范围：按起止日期每天展开，不以库中零散场次为准
            if (this.shouldExpandUnifiedDateRangeSessions(normalized)) {
                return this.expandUnifiedDateRangeSessions(normalized);
            }
            const sessions = normalized.Sessions || [];
            if (sessions.length) {
                const sorted = sessions.slice().sort((a, b) => {
                    const aDate = a.SpecificDate || a.specificDate;
                    const bDate = b.SpecificDate || b.specificDate;
                    if (aDate && bDate) return new Date(aDate) - new Date(bDate);
                    if (aDate) return -1;
                    if (bDate) return 1;
                    const aWd = a.Weekday != null ? a.Weekday : a.weekday;
                    const bWd = b.Weekday != null ? b.Weekday : b.weekday;
                    return (aWd || 0) - (bWd || 0);
                });
                return sorted.map((s) => this.mapStudentEventSessionItem(s));
            }
            return [];
        },
        /** 单条场次转表格行 */
        mapStudentEventSessionItem(s) {
            const start = this.formatTimeOnly(s.StartTime || s.startTime);
            const end = this.formatTimeOnly(s.EndTime || s.endTime);
            const timeRange = start || end ? `${start}${end ? (' - ' + end) : ''}` : '—';
            let dateLabel = '—';
            if (s.SpecificDate || s.specificDate) {
                dateLabel = this.formatDateOnly(s.SpecificDate || s.specificDate);
            } else if (s.Weekday != null || s.weekday != null) {
                dateLabel = this.weekdayToLabel(s.Weekday != null ? s.Weekday : s.weekday);
            }
            return { dateLabel, timeRange };
        },
        loadEvents(params = {}) {
            this.eventsLoading = true;
            const page = params.page || this.eventsPage || 1;
            const intPageSize = params.intPageSize || this.eventsPageSize || 10;
            const status = Object.prototype.hasOwnProperty.call(params, 'status')
                ? (params.status || '')
                : (this.eventsStatus || '');
            const para = Object.assign({ page: page, intPageSize: intPageSize }, params);
            if (status) para.status = status;
            else delete para.status;
            if (!Object.prototype.hasOwnProperty.call(params, 'professionalGroupTypeId')) {
                para.professionalGroupTypeId = this.eventsProfessionalGroupTypeId || 0;
            }
            if (!Object.prototype.hasOwnProperty.call(params, 'keyword')) {
                para.keyword = this.eventsKeyword || '';
            }
            if (!Object.prototype.hasOwnProperty.call(params, 'startDate')) {
                para.startDate = this.eventsDateRange && this.eventsDateRange[0] || '';
                para.endDate = this.eventsDateRange && this.eventsDateRange[1] || '';
            }
            getEvents(para).then((res) => {
                this.eventsLoading = false;
                let list = [];
                if (res && res.data && res.data.response) {
                    const r = res.data.response;
                    if (Array.isArray(r.data)) list = r.data;
                    else if (Array.isArray(r)) list = r;
                    else if (Array.isArray(r.list)) list = r.list;
                    else if (Array.isArray(r.items)) list = r.items;
                    else list = [];
                    // 读取分页信息（若后端返回）
                    this.eventsTotal = r.dataCount || r.total || (Array.isArray(r.data) ? r.data.length : list.length) || 0;
                    if (r.Page) this.eventsPage = r.Page;
                    if (r.PageSize) this.eventsPageSize = r.PageSize;
                } else if (res && res.data) {
                    if (Array.isArray(res.data)) list = res.data;
                    else if (Array.isArray(res.data.data)) list = res.data.data;
                    else list = [];
                    this.eventsTotal = list.length;
                } else {
                    list = [];
                    this.eventsTotal = 0;
                }
                // 将后端返回的时间字段中等于 0（或字符串 '0'）的值归一化为 null，避免日期选择器/显示出现 1970 年
                this.events = Array.isArray(list) ? list.map(it => {
                    if (!it) return it;
                    if (it.StartDate === 0 || it.StartDate === '0' || it.StartDate === '') it.StartDate = null;
                    if (it.EndDate === 0 || it.EndDate === '0' || it.EndDate === '') it.EndDate = null;
                    return it;
                }) : [];
                this.$nextTick(() => this.relayoutEventListTable());
            }).catch(() => { this.eventsLoading = false; this.events = []; this.eventsTotal = 0; });
        },
        handleEventsPageChange(page) {
            this.eventsPage = page;
            const orgId = this.currentOrgForEvents ? this.currentOrgForEvents.Id : (this.eventForm && this.eventForm.OrganizationId ? this.eventForm.OrganizationId : 0);
            this.loadEvents({ organizationId: orgId, page: this.eventsPage, intPageSize: this.eventsPageSize, status: this.eventsStatus });
        },
        /** 活动状态筛选变更后回到第一页重查。最后更新：2026-09-22 */
        handleEventsStatusChange() {
            this.eventsPage = 1;
            this.handleEventsFilterChange();
        },
        handleEventsFilterChange() {
            this.eventsPage = 1;
            const orgId = this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0;
            this.loadEvents({ organizationId: orgId, page: 1, intPageSize: this.eventsPageSize });
        },
        /** 活动状态对应 Tag 颜色。最后更新：2026-09-22 */
        eventStatusTagType(status) {
            if (status === 'NotStarted') return 'info';
            if (status === 'Ongoing') return 'success';
            if (status === 'Ended') return 'warning';
            return 'info';
        },
        /** 活动状态码转中文（后端未回 StatusText 时兜底）。最后更新：2026-09-22 */
        eventStatusText(status) {
            if (status === 'NotStarted') return '未开始';
            if (status === 'Ongoing') return '进行中';
            if (status === 'Ended') return '已结束';
            return '';
        },
        showEventParticipants(row) {
            if (!row) return;
            this.eventParticipantEventName = row.Title || '活动';
            this.eventParticipantTitle = `查看活动参与人员 - ${this.eventParticipantEventName}`;
            this.eventParticipantTime = (row.StartDate ? this.formatDateOnly(row.StartDate) : '')
                + (row.EndDate ? (' - ' + this.formatDateOnly(row.EndDate)) : '');
            let rows = [];
            if (Array.isArray(row.ParticipantDetails) && row.ParticipantDetails.length) {
                rows = row.ParticipantDetails.map(item => {
                    if (!item) return null;
                    const name = item.StudentName || item.studentName || '';
                    if (!name) return null;
                    return {
                        name,
                        dormText: item.DormText || item.dormText || ''
                    };
                }).filter(Boolean);
            } else {
                let names = [];
                if (row.ParticipantUserNames) {
                    if (typeof row.ParticipantUserNames === 'string') names = row.ParticipantUserNames.split(',');
                    else if (Array.isArray(row.ParticipantUserNames)) names = row.ParticipantUserNames.map(x => (typeof x === 'string' ? x : (x.Name || '')));
                } else if (row.ParticipantNames) {
                    names = Array.isArray(row.ParticipantNames) ? row.ParticipantNames : (typeof row.ParticipantNames === 'string' ? row.ParticipantNames.split(',') : []);
                } else if (row.MemberIds && typeof row.MemberIds === 'string') {
                    names = row.MemberIds.split(',');
                } else if (row.Members && Array.isArray(row.Members)) {
                    names = row.Members.map(m => (m && (m.Name || m.RealName || m.UserName || m.DisplayName)) || '').filter(Boolean);
                }
                rows = names.map(name => String(name || '').trim()).filter(Boolean).map(name => ({ name, dormText: '' }));
            }
            this.eventParticipantRows = rows;
            this.eventParticipantFilterKey = '';
            this.eventParticipantPage = 1;
            this.eventParticipantPageSize = 20;
            this.eventParticipantDialogVisible = true;
        },
        /** 复制活动全部参与人姓名。创建于 2026-10-20 */
        copyAllEventParticipantNames() {
            const names = (this.filteredEventParticipantRows || []).map(item => item.name).filter(Boolean);
            if (!names.length) {
                this.$message.warning('暂无可复制的内容');
                return;
            }
            this.copyTextToClipboard(names.join('、'));
            this.$message.success(`已复制 ${names.length} 名参与人姓名`);
        },
        showMemberDialog(row) {
            if (!row) return;
            this.currentMemberOrg = row;
            this.memberDialogTitle = `查看组织成员 - ${row.Name || '组织'}`;
            this.memberDialogList = this.getMemberNamesList(row);
            this.memberDialogFilterKey = '';
            this.memberDialogPage = 1;
            this.memberDialogPageSize = 20;
            this.memberDialogVisible = true;
        },
        // 复制全部成员姓名
        copyAllMemberNames() {
            const names = (this.filteredMemberDialogNames || []).filter(Boolean);
            if (!names.length) {
                this.$message.warning('暂无可复制的内容');
                return;
            }
            this.copyTextToClipboard(names.join('、'));
            this.$message.success(`已复制 ${names.length} 名成员姓名`);
        },
        // 复制单个成员姓名
        copySingleMemberName(text) {
            if (!text) return;
            this.copyTextToClipboard(text);
            this.$message.success(`已复制: ${text}`);
        },
        // 打开管理员详情弹窗。最后更新：2026-09-08
        openAdminViewDialog(row) {
            if (!row) return;
            this.currentAdminOrg = row;
            this.adminDialogList = this.getAdminNamesList(row.AdminNames);
            this.adminDialogTitle = `查看管理员 - ${row.Name || '组织'}`;
            this.adminDialogFilterKey = '';
            this.adminDialogVisible = true;
        },
        // 复制全部管理员姓名
        copyAllAdminNames() {
            const names = (this.filteredAdminDialogList || []).map(item => item.name).filter(Boolean);
            if (!names.length) {
                this.$message.warning('暂无可复制的内容');
                return;
            }
            this.copyTextToClipboard(names.join('、'));
            this.$message.success(`已复制 ${names.length} 名管理员姓名`);
        },
        // 复制单个管理员姓名
        copySingleAdminName(text) {
            if (!text) return;
            this.copyTextToClipboard(text);
            this.$message.success(`已复制: ${text}`);
        },
        // 通用剪贴板复制工具
        copyTextToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).catch(() => {
                    this.fallbackCopyText(text);
                });
            } else {
                this.fallbackCopyText(text);
            }
        },
        fallbackCopyText(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                console.error('复制失败', err);
            }
            document.body.removeChild(textArea);
        },
        addEventOpen() {
            this.eventFormVisible = true;
            this.eventForm = { Id: 0, OrganizationId: this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0, Title: '', Description: '', Location: '', StartDate: null, EndDate: null, ParticipantUserIds: [], ProfessionalGroupTypeId: null, ManagerTeacherUserIds: [], ManagerSetterTeacherUserIds: [], ScheduleMode: 1, IsUnifiedTimeSlot: true, UnifiedStartTime: null, UnifiedEndTime: null, Sessions: [], WeekNumbers: [] };
            // 新增时加载该组织成员供选择
            const orgId = this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0;
            this.currentOrgMembers = [];
            // reset sessions and week options
            this.dateSessions = [];
            this.weekdaySessions.forEach(w => { w.enabled = false; w.startTime = null; w.endTime = null; });
            this.weekOptions = [];
            this.eventForm.WeekNumbers = [];
            if (orgId) {
                getMembers({ organizationId: orgId }).then((res) => {
                    let list = [];
                    if (res && res.data && res.data.response) list = res.data.response;
                    else if (res && res.data) list = res.data;
                    this.currentOrgMembers = Array.isArray(list) ? list : [];
                }).catch(() => { this.currentOrgMembers = []; });
            }
            this.loadEventFormTeacherList();
            this.loadProfessionalGroupTypes();
        },
        editEventOpen(row) {
            this.eventFormVisible = true;
            this.eventForm = Object.assign({}, row);
            // 如果后端以 0 或 '0' 表示空时间，把它转换为 null，以避免 date-picker 显示 1970-01-01
            if (this.eventForm) {
                if (this.eventForm.StartDate === 0 || this.eventForm.StartDate === '0' || this.eventForm.StartDate === '') this.eventForm.StartDate = null;
                if (this.eventForm.EndDate === 0 || this.eventForm.EndDate === '0' || this.eventForm.EndDate === '') this.eventForm.EndDate = null;
            }
            const mgrParsed = this.normalizeEventManagerIdsFromRow(row);
            this.$set(this.eventForm, 'ManagerTeacherUserIds', mgrParsed && mgrParsed.length ? mgrParsed.map(x => String(x)) : []);
            const mgrSetterParsed = this.normalizeEventManagerSetterIdsFromRow(row);
            this.$set(this.eventForm, 'ManagerSetterTeacherUserIds', mgrSetterParsed && mgrSetterParsed.length ? mgrSetterParsed.map(x => String(x)) : []);
            // 参与人员 Id：兼容 ParticipantUserIds / MemberIds
            let participantIds = [];
            if (Array.isArray(this.eventForm.ParticipantUserIds) && this.eventForm.ParticipantUserIds.length) {
                participantIds = this.eventForm.ParticipantUserIds;
            } else if (typeof this.eventForm.MemberIds === 'string' && this.eventForm.MemberIds) {
                participantIds = this.eventForm.MemberIds.split(',');
            } else if (Array.isArray(this.eventForm.MemberIds)) {
                participantIds = this.eventForm.MemberIds;
            }
            this.$set(this.eventForm, 'ParticipantUserIds', participantIds.map(x => String(x)).filter(Boolean));
            // 编辑时加载该组织成员供选择（优先使用活动记录中的 OrganizationId）
            const orgId = this.eventForm.OrganizationId || (this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0);
            this.currentOrgMembers = [];
            if (orgId) {
                getMembers({ organizationId: orgId }).then((res) => {
                    let list = [];
                    if (res && res.data && res.data.response) list = res.data.response;
                    else if (res && res.data) list = res.data;
                    this.currentOrgMembers = Array.isArray(list) ? list : [];
                }).catch(() => { this.currentOrgMembers = []; });
            }
            this.loadEventFormTeacherList();
            // 初始化调度相关字段（兼容后端可能的字段名）
            this.eventForm.ScheduleMode = this.eventForm.ScheduleMode || this.eventForm.ScheduleMode === 0 ? this.eventForm.ScheduleMode : (this.eventForm.ScheduleMode || 1);
            this.eventForm.IsUnifiedTimeSlot = (this.eventForm.IsUnifiedTimeSlot === false) ? false : (this.eventForm.IsUnifiedTimeSlot || true);
            this.eventForm.UnifiedStartTime = this.eventForm.UnifiedStartTime || null;
            this.eventForm.UnifiedEndTime = this.eventForm.UnifiedEndTime || null;
            const sessions = this.eventForm.Sessions || this.eventForm.EventSessions || this.eventForm.OrganizationEventSessions || [];
            // reset weekdaySessions and dateSessions
            this.dateSessions = [];
            this.weekdaySessions.forEach(w => { w.enabled = false; w.startTime = null; w.endTime = null; });
            if (Array.isArray(sessions) && sessions.length > 0) {
                sessions.forEach(s => {
                    if (s.SpecificDate || s.specificDate) {
                        const sd = s.SpecificDate || s.specificDate;
                        this.dateSessions.push({ date: this.formatDateOnly(sd), startTime: s.StartTime || s.startTime || null, endTime: s.EndTime || s.endTime || null });
                    } else if (s.Weekday || s.weekday) {
                        const wd = Number(s.Weekday || s.weekday);
                        const ws = this.weekdaySessions.find(x => x.weekday === wd);
                        if (ws) {
                            ws.enabled = true;
                            ws.startTime = s.StartTime || s.startTime || null;
                            ws.endTime = s.EndTime || s.endTime || null;
                        }
                    }
                });
            }
            // 初始化 WeekNumbers（兼容后端字段 WeekNumbers/Weeks）
            this.eventForm.WeekNumbers = this.eventForm.WeekNumbers || this.eventForm.Weeks || this.eventForm.WeekList || [];
            // 生成 weekOptions（如果为周次模式）
            if (this.eventForm.ScheduleMode === 2) {
                this.buildWeekOptionsFromRange();
                this.buildAvailableWeekdaysFromRange();
            } else if (this.eventForm.ScheduleMode === 1) {
                this.buildDateSessionsFromRange();
            }
            // 加载 event 编辑时的事件列表第一页数据（与当前组织有关）
            const orgIdForEvents = this.eventForm.OrganizationId || (this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0);
            this.eventsPage = 1;
            this.loadEvents({ organizationId: orgIdForEvents, page: this.eventsPage, intPageSize: this.eventsPageSize });
        },
        deleteEventRow(row) {
            if (!row) return;
            this.$confirm('确认删除该活动吗?', '提示', { type: 'warning' }).then(() => {
                deleteEvent({ id: row.Id }).then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message({ message: '删除成功', type: 'success' });
                        this.loadEvents({ organizationId: this.currentOrgForEvents.Id });
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                }).catch(() => { });
            }).catch(() => { });
        },
        eventSubmit() {
            this.$refs.eventForm.validate((valid) => {
                if (!valid) return;
                // 在提交前将前端编辑的按日/周时段同步到 eventForm.Sessions
                this.collectSessionsToForm();
                // 先进行时间逻辑校验（统一时段或各场次），防止结束早于开始
                const unifiedCheck = this.validateUnifiedTimesSync();
                if (!unifiedCheck.ok) { this.$message.error(unifiedCheck.msg); return; }
                const sessionsCheck = this.validateSessionsSync();
                if (!sessionsCheck.ok) { this.$message.error(sessionsCheck.msg); return; }
                const managerIdSet = new Set(
                    (Array.isArray(this.eventForm.ManagerTeacherUserIds) ? this.eventForm.ManagerTeacherUserIds : [])
                        .map(x => String(x))
                );
                const setterIds = (Array.isArray(this.eventForm.ManagerSetterTeacherUserIds) ? this.eventForm.ManagerSetterTeacherUserIds : [])
                    .map(x => String(x));
                if (setterIds.length > 0 && setterIds.some(id => !managerIdSet.has(id))) {
                    this.$message.error('指导老师维护者必须从指导老师中选择');
                    return;
                }

                const para = Object.assign({}, this.eventForm);
                para.OrganizationId = para.OrganizationId || (this.currentOrgForEvents ? this.currentOrgForEvents.Id : 0);
                // 将选择的参与成员数组规范化为后端 ParticipantUserIds，并兼容旧 MemberIds
                if (para.ParticipantUserIds && Array.isArray(para.ParticipantUserIds)) {
                    para.ParticipantUserIds = para.ParticipantUserIds.map(x => String(x)).filter(Boolean);
                    para.MemberIds = para.ParticipantUserIds.join(',');
                } else {
                    para.ParticipantUserIds = [];
                    para.MemberIds = '';
                }
                // 活动开始/结束只传日期，避免时区导致的 UTC 时间串（例如 2026-01-05T16:00:00.000Z）
                para.StartDate = this.eventForm.StartDate ? this.formatDateOnly(this.eventForm.StartDate) : null;
                para.EndDate = this.eventForm.EndDate ? this.formatDateOnly(this.eventForm.EndDate) : null;
                // 将调度相关字段显式传给后端（后端可选择接收或忽略）
                para.ScheduleMode = this.eventForm.ScheduleMode;
                para.IsUnifiedTimeSlot = this.eventForm.IsUnifiedTimeSlot;
                para.UnifiedStartTime = this.eventForm.UnifiedStartTime || null;
                para.UnifiedEndTime = this.eventForm.UnifiedEndTime || null;
                // 活动地点
                para.Location = this.eventForm.Location || '';
                // 非统一或统一时段均通过 collectSessionsToForm 生成 this.eventForm.Sessions
                // 后端可能需要明确的 Sessions（Weekday 或 SpecificDate 条目），因此总是传送 Sessions
                para.Sessions = Array.isArray(this.eventForm.Sessions) ? this.eventForm.Sessions : [];
                para.ManagerTeacherUserIds = Array.isArray(this.eventForm.ManagerTeacherUserIds)
                    ? this.eventForm.ManagerTeacherUserIds.filter(x => x != null && x !== '').map(x => String(x)) : [];
                para.ManagerSetterTeacherUserIds = Array.isArray(this.eventForm.ManagerSetterTeacherUserIds)
                    ? this.eventForm.ManagerSetterTeacherUserIds.filter(x => x != null && x !== '').map(x => String(x)) : [];
                const api = para.Id ? updateEvent : addEvent;
                api(para).then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message({ message: '保存成功', type: 'success' });
                        this.eventFormVisible = false;
                        this.loadEvents({ organizationId: this.currentOrgForEvents.Id });
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                }).catch(() => { });
            });
        },
        editSubmit() {
            this.$refs.editForm.validate((valid) => {
                if (!valid) return;
                this.editLoading = true;
                // 组织人员：提交前按已选明细同步为 [deptId, studentId][]
                this.syncOrgMemberUserIdsFromItems();
                const para = Object.assign({}, this.editForm);
                // 只传后端标准字段，避免大小写并存造成绑定歧义
                para.AllTeachersAsAdmins = this.toBool(this.editForm.AllTeachersAsAdmins);
                delete para.allTeachersAsAdmins;
                // 已经由上下文统一绑定学校ID，无需从 Dids 中解析
                if (!para.DepartmentId) {
                    para.DepartmentId = this.DepartmentId || 0;
                }
                // 管理员：全部教职工模式清空 AdminIds；否则按多选转字符串
                this.syncOrgAdminIdsFromItems();
                para.AdminIdsArray = Array.isArray(this.editForm.AdminIdsArray) ? [...this.editForm.AdminIdsArray] : [];
                if (para.AllTeachersAsAdmins) {
                    para.AdminIds = '';
                    para.AdminIdsArray = [];
                } else if (para.AdminIdsArray && para.AdminIdsArray.length > 0) {
                    para.AdminIds = para.AdminIdsArray.join(',');
                } else {
                    para.AdminIds = '';
                }
                // 组织人员：有选择则保留 MemberUserIds 供后端解析，无选择则传空数组
                if (!para.MemberUserIds || !Array.isArray(para.MemberUserIds) || para.MemberUserIds.length === 0) {
                    para.MemberUserIds = [];
                }
                if (para.ParentId === 0) para.ParentId = null;
                const api = para.Id ? updateOrganization : addOrganization;
                api(para).then((res) => {
                    this.editLoading = false;
                    if (res && res.data && res.data.success) {
                        this.$message({ message: '保存成功', type: 'success' });
                        this.editFormVisible = false;
                        this.loadList();
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                }).catch(() => { this.editLoading = false; });
            });
        },

        handleAllTeachersAsAdminsChange(val) {
            const nextVal = this.toBool(val);
            if (nextVal) {
                // 勾选前缓存当前管理员，便于未保存前取消时恢复
                if (Array.isArray(this.editForm.AdminIdsArray) && this.editForm.AdminIdsArray.length > 0) {
                    this.adminIdsDraftBeforeAllTeachers = [...this.editForm.AdminIdsArray];
                    this.adminItemsDraftBeforeAllTeachers = (this.orgAdminSelectedItems || []).map(x => ({ ...x }));
                }
            }
            this.editForm.AllTeachersAsAdmins = nextVal;
            if (this.editForm.AllTeachersAsAdmins) {
                this.editForm.AdminIdsArray = [];
                this.orgAdminSelectedItems = [];
            } else if ((!this.editForm.AdminIdsArray || this.editForm.AdminIdsArray.length === 0)
                && this.adminIdsDraftBeforeAllTeachers && this.adminIdsDraftBeforeAllTeachers.length > 0) {
                // 取消勾选时，如当前为空则回填上次草稿
                this.editForm.AdminIdsArray = [...this.adminIdsDraftBeforeAllTeachers];
                if (Array.isArray(this.adminItemsDraftBeforeAllTeachers) && this.adminItemsDraftBeforeAllTeachers.length) {
                    this.orgAdminSelectedItems = this.adminItemsDraftBeforeAllTeachers.map(x => ({ ...x }));
                } else {
                    this.hydrateOrgAdminSelectedItems({
                        AdminIds: this.editForm.AdminIdsArray.join(','),
                        AdminNames: ''
                    });
                }
            }
        },
        /** 从行数据回填组织管理员已选明细。创建于 2026-09-22 */
        hydrateOrgAdminSelectedItems(row) {
            const ids = Array.isArray(this.editForm.AdminIdsArray)
                ? this.editForm.AdminIdsArray.map(x => String(x)).filter(Boolean)
                : [];
            const names = this.getAdminNamesList(row && row.AdminNames);
            this.orgAdminSelectedItems = ids.map((id, idx) => ({
                id,
                name: names[idx] || id,
                personType: 'teacher'
            }));
        },
        /** 从行数据回填组织人员已选明细（MemberUserIds 为 [deptId, studentId]）。创建于 2026-09-22 */
        hydrateOrgMemberSelectedItems(row) {
            let paths = [];
            if (row && Array.isArray(row.MemberUserIds) && row.MemberUserIds.length) {
                paths = row.MemberUserIds;
            } else if (this.editForm && Array.isArray(this.editForm.MemberUserIds)) {
                paths = this.editForm.MemberUserIds;
            }
            const names = String((row && row.MemberUserNames) || this.editForm.MemberUserNames || '')
                .split(/[,，、;；]/)
                .map(s => s.trim())
                .filter(Boolean);
            const items = [];
            paths.forEach((path, idx) => {
                let deptId = '';
                let id = '';
                if (Array.isArray(path)) {
                    deptId = path[0] != null ? String(path[0]) : '';
                    id = path[path.length - 1] != null ? String(path[path.length - 1]) : '';
                } else if (path != null && path !== '') {
                    id = String(path);
                }
                if (!id) return;
                items.push({
                    id,
                    name: names[idx] || id,
                    deptId,
                    personType: 'student'
                });
            });
            this.orgMemberSelectedItems = items;
            this.syncOrgMemberUserIdsFromItems();
        },
        syncOrgAdminIdsFromItems() {
            this.editForm.AdminIdsArray = (this.orgAdminSelectedItems || []).map(x => String(x.id));
        },
        syncOrgMemberUserIdsFromItems() {
            this.editForm.MemberUserIds = (this.orgMemberSelectedItems || []).map(item => [
                String(item.deptId || '0'),
                String(item.id)
            ]);
        },
        openOrgAdminPicker() {
            if (!this.editForm.DepartmentId || !this.editForm.CampusId) {
                this.$message.warning('请先选择所属机构与校区');
                return;
            }
            if (this.editForm.AllTeachersAsAdmins) return;
            this.orgAdminPickerVisible = true;
        },
        onOrgAdminsPicked(people) {
            this.orgAdminSelectedItems = (people || []).map(p => ({
                id: String(p.id),
                name: p.name || String(p.id),
                personType: 'teacher',
                deptId: p.deptId != null ? String(p.deptId) : '',
                deptLabel: p.deptLabel || ''
            }));
            this.syncOrgAdminIdsFromItems();
            this.adminIdsDraftBeforeAllTeachers = [...this.editForm.AdminIdsArray];
        },
        clearOrgAdmins() {
            this.orgAdminSelectedItems = [];
            this.editForm.AdminIdsArray = [];
        },
        removeOrgAdmin(id) {
            const key = String(id);
            this.orgAdminSelectedItems = (this.orgAdminSelectedItems || []).filter(x => String(x.id) !== key);
            this.syncOrgAdminIdsFromItems();
        },
        openOrgMemberPicker() {
            if (!this.editForm.DepartmentId || !this.editForm.CampusId) {
                this.$message.warning('请先选择所属机构与校区');
                return;
            }
            this.orgMemberPickerVisible = true;
        },
        onOrgMembersPicked(people) {
            this.orgMemberSelectedItems = (people || []).map(p => ({
                id: String(p.id),
                name: p.name || String(p.id),
                personType: 'student',
                deptId: p.deptId != null ? String(p.deptId) : '0',
                deptLabel: p.deptLabel || ''
            }));
            this.syncOrgMemberUserIdsFromItems();
        },
        clearOrgMembers() {
            this.orgMemberSelectedItems = [];
            this.editForm.MemberUserIds = [];
        },
        removeOrgMember(id) {
            const key = String(id);
            this.orgMemberSelectedItems = (this.orgMemberSelectedItems || []).filter(x => String(x.id) !== key);
            this.syncOrgMemberUserIdsFromItems();
        },
        openEventParticipantPicker() {
            this.eventParticipantPickerVisible = true;
        },
        onEventParticipantsPicked(ids) {
            this.$set(this.eventForm, 'ParticipantUserIds', (ids || []).map(x => String(x)));
        },
        clearEventParticipants() {
            this.$set(this.eventForm, 'ParticipantUserIds', []);
        },
        removeEventParticipant(id) {
            const key = String(id);
            const next = (this.eventForm.ParticipantUserIds || []).map(x => String(x)).filter(x => x !== key);
            this.$set(this.eventForm, 'ParticipantUserIds', next);
        },
        openEventManagerPicker() {
            this.eventManagerPickerVisible = true;
        },
        onEventManagersPicked(ids) {
            this.$set(this.eventForm, 'ManagerTeacherUserIds', (ids || []).map(x => String(x)));
            this.sanitizeEventManagerSelections();
        },
        clearEventManagers() {
            this.$set(this.eventForm, 'ManagerTeacherUserIds', []);
            this.sanitizeEventManagerSelections();
        },
        removeEventManager(id) {
            const key = String(id);
            const next = (this.eventForm.ManagerTeacherUserIds || []).map(x => String(x)).filter(x => x !== key);
            this.$set(this.eventForm, 'ManagerTeacherUserIds', next);
            this.sanitizeEventManagerSelections();
        },
        openEventManagerSetterPicker() {
            this.eventManagerSetterPickerVisible = true;
        },
        onEventManagerSettersPicked(ids) {
            this.$set(this.eventForm, 'ManagerSetterTeacherUserIds', (ids || []).map(x => String(x)));
            this.sanitizeEventManagerSelections();
        },
        clearEventManagerSetters() {
            this.$set(this.eventForm, 'ManagerSetterTeacherUserIds', []);
        },
        removeEventManagerSetter(id) {
            const key = String(id);
            const next = (this.eventForm.ManagerSetterTeacherUserIds || []).map(x => String(x)).filter(x => x !== key);
            this.$set(this.eventForm, 'ManagerSetterTeacherUserIds', next);
        },
        handleChange(value) {
            // value 为 cascader 返回的数组；切换所属机构时需清空校区、管理员、成员
            this.editForm.AdminIdsArray = [];
            this.editForm.AllTeachersAsAdmins = false;
            this.editForm.MemberUserIds = [];
            this.orgAdminSelectedItems = [];
            this.orgMemberSelectedItems = [];
            this.$set(this.editForm, 'CampusId', null);
            let id = 0;
            if (Array.isArray(value) && value.length > 0) {
                if (value.length > 1) id = value[value.length - 1];
                else id = value[0] || 0;
            }
            this.editForm.DepartmentId = id;
            if (id) {
                this.loadCampusOptions(id);
            } else {
                this.campusOptions = [];
            }
        },
        loadCampusOptions(deptId) {
            const schoolId = deptId || this.editForm.DepartmentId || this.DepartmentId;
            if (schoolId && schoolId !== 0) {
                return getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
                    if (res.data.success) {
                        this.campusOptions = res.data.response.data || [];
                        const campusSearch = this.searchList.find(e => e.key === 'campusId');
                        if (campusSearch) {
                            campusSearch.options = this.campusOptions.map(e => ({ label: e.Name, value: e.Id }));
                        }
                    }
                    return this.campusOptions;
                }).catch(() => {
                    this.campusOptions = [];
                    return [];
                });
            }
            return getSchoolDepartmentTree({ pid: 0, type: 1 }).then(res => {
                if (res.data.success && res.data.response) {
                    return this.loadCampusOptions(res.data.response.value);
                }
                return [];
            });
        },
        handleCampusChange() {
            // 校区切换不强制清空已选；通讯录按 DepartmentId 重新选人即可
        },
        getCampusName(campusId) {
            if (!campusId || campusId === 0 || campusId === '0') return '-';
            if (this.campusOptions.length) {
                const campus = this.campusOptions.find(c => c.Id === campusId);
                if (campus) return campus.Name;
            }
            const org = this.organizations.find(o => o.CampusId === campusId);
            return org && org.CampusName ? org.CampusName : '-';
        },
        buildParentOptions(list) {
            this.parentOptions = (list || []).map(i => ({ Id: i.Id, Name: i.Name }));
        },
        loadList(params = {}) {
            this.listLoading = true;
            const para = Object.assign(
                { page: this.page, intPageSize: this.PageSize, departmentId: this.DepartmentId },
                params,
                this.filters
            );
            getOrganizations(para).then((res) => {
                this.listLoading = false;
                let data = [];
                if (res && res.data && res.data.response) {
                    data = res.data.response.data || res.data.response;
                    this.total = res.data.response.dataCount || (data.length || 0);
                    if (res.data.response.PageSize) this.PageSize = res.data.response.PageSize;
                    if (res.data.response.Page) this.page = res.data.response.Page;
                } else if (res && res.data && Array.isArray(res.data)) data = res.data;
                else if (res && res.data && res.data.data) data = res.data.data;
                else data = res.data || [];

                // 如果后端返回扁平列表，需构建树；如果直接返回树，请适配
                this.organizations = Array.isArray(data) ? data : [];
                this.buildParentOptions(this.organizations);
                // 补 ParentName
                const idMap = {};
                this.organizations.forEach(i => { if (i && i.Id != null) idMap[i.Id] = i.Name; });
                this.organizations.forEach(it => { const pid = it.ParentId == null ? 0 : it.ParentId; it.ParentName = pid === 0 ? '顶级' : (idMap[pid] || ''); });

                // 合并成员姓名用于列表展示（兼容后端返回字符串或成员对象数组），写入 MemberUserNames
                this.organizations.forEach(it => {
                    if (!it) return;
                    it._memberNamesCache = null;
                    // 优先用 MemberUserIds 计人数，避免拆分超长姓名串
                    if (Array.isArray(it.MemberUserIds) && it.MemberUserIds.length) {
                        it.MemberCount = it.MemberUserIds.length;
                    } else if (typeof it.MemberUserNames === 'string' && it.MemberUserNames) {
                        it.MemberCount = it.MemberUserNames.split(/[,，、;；]/).filter(s => s && s.trim()).length;
                    } else {
                        it.MemberCount = 0;
                    }
                    // 已经是字符串则保留
                    if (it.MemberUserNames && typeof it.MemberUserNames === 'string') {
                        return;
                    }
                    // 常见的成员数组字段
                    const arr = it.Members || it.MemberList || it.MemberUsers || it.MembersList || it.MemberUserList || it.Users || it.MemberInfos || it.MemberUserNames;
                    if (Array.isArray(arr) && arr.length > 0) {
                        const names = arr.map(m => (m && (m.Name || m.RealName || m.TeacherName || m.StudentName || m.UserName || m.DisplayName)) || '').filter(Boolean);
                        it.MemberUserNames = names.join(',');
                        it.MemberCount = names.length;
                        it._memberNamesCache = names;
                    } else if (it.MemberUserNames && Array.isArray(it.MemberUserNames)) {
                        const names = it.MemberUserNames.map(x => (typeof x === 'string' ? x : (x.Name || ''))).filter(Boolean);
                        it.MemberUserNames = names.join(',');
                        it.MemberCount = names.length;
                        it._memberNamesCache = names;
                    } else {
                        it.MemberUserNames = it.MemberUserNames || '';
                    }
                });
            }).catch(() => { this.listLoading = false; });
        },
        handleCurrentChange(val) { this.page = val; this.loadList(); },
        handleSizeChange(val) { this.PageSize = val; this.page = 1; this.loadList(); },
    },
    watch: {
        memberDialogFilterKey() {
            this.memberDialogPage = 1;
        },
        eventParticipantFilterKey() {
            this.eventParticipantPage = 1;
        },
        'editForm.ParentId': function (val) {
            this.editForm.Level = (val && val !== 0) ? 2 : 1;
        }
        ,
        // 监听活动开始/结束时间区域变化，生成每天的时段条目
        eventDateRange: function (val) {
            // eventDateRange 的 setter 已经会写入 eventForm.StartDate/EndDate
            if (!this.eventForm) return;
            if (this.eventForm.ScheduleMode === 1) {
                this.buildDateSessionsFromRange();
            }
            if (this.eventForm.ScheduleMode === 2) {
                this.buildWeekOptionsFromRange();
            }
            // 计算并限制可选的星期
            this.buildAvailableWeekdaysFromRange();
        },
        'eventForm.ScheduleMode': function (val) {
            // 当切换到按日期模式，依据当前范围生成 dateSessions
            if (val === 1) {
                this.buildDateSessionsFromRange();
            }
            if (val === 2) {
                this.buildWeekOptionsFromRange();
                this.buildAvailableWeekdaysFromRange();
            }
        },
        'eventForm.IsUnifiedTimeSlot': function (val) {
            // 当切换到非统一时段且为按日期模式时，生成 dateSessions
            if (!val && this.eventForm.ScheduleMode === 1) {
                this.buildDateSessionsFromRange();
            }
        },
        'eventForm.ManagerTeacherUserIds': function () {
            // 指导老师变更后，维护者下拉源会收敛到指导老师范围，需要同步清理无效已选值
            this.sanitizeEventManagerSelections();
        },
        currentOrgForEvents: {
            deep: true,
            handler() {
                // 切换组织后，指导老师下拉源会变化，需要同步清理无效已选值
                this.sanitizeEventManagerSelections();
            }
        }
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        this.buttonList.push(
            {
                name: '活动总览权限',
                Func: 'openEventOverviewPermissionDialog',
                btnType: 'primary',
                icon: 'el-icon-view',
                forceAction: true,
            },
            {
                name: '专业组维护',
                Func: 'openProfessionalGroupDialog',
                btnType: 'primary',
                icon: 'el-icon-collection-tag',
                forceAction: true,
            },
            {
                name: '按学生查活动',
                Func: 'openStudentEventQueryDialog',
                btnType: 'primary',
                icon: 'el-icon-search',
                forceAction: true,
            }
        );
    }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
}

/* 表格自适应容器，min-width 列在宽屏时自动扩展减少截断 */
.org-tree-tbl {
    max-width: 100%;
}

/* 两级组织列表：子行样式 */
.org-tree-tbl /deep/ .org-row-child {
    background-color: #fafbfc;
}

.org-tree-tbl /deep/ .org-row-child:hover {
    background-color: #f0f9ff !important;
}

/* 组织列表：校区 + 短标识；表头/单元格强制左对齐，避免全局 th 居中错位。最后更新：2026-10-28 */
.org-tree-tbl /deep/ .org-campus-short-col > .cell {
    text-align: left !important;
    padding-left: 10px;
    padding-right: 10px;
}
.org-campus-short-cell {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr);
    column-gap: 6px;
    row-gap: 4px;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding: 2px 0;
    text-align: left;
}
.org-campus-short-label {
    justify-self: end;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
    text-align: right;
}
.org-campus-short-value {
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.org-short-tag {
    font-size: 12px;
    line-height: 20px;
    color: #606266;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 活动事件：标题/描述、指导老师/维护者合并列。创建于 2026-10-28 */
.event-title-desc-cell {
    line-height: 1.35;
    padding: 2px 0;
}
.event-title-line {
    font-size: 13px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.event-desc-line {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.event-time-merge-cell {
    line-height: 1.35;
    padding: 2px 0;
}
.event-time-line {
    font-size: 13px;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.event-create-line {
    margin-top: 2px;
    font-size: 12px;
    color: #909399;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 两列网格：标签右对齐、姓名左对齐，老师/维护纵向对齐。最后更新：2026-10-28 */
.event-teacher-merge-cell {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr);
    column-gap: 6px;
    row-gap: 4px;
    align-items: center;
    padding: 2px 0;
}
.event-teacher-label {
    justify-self: end;
    font-size: 12px;
    line-height: 20px;
    color: #909399;
    text-align: right;
}
.event-teacher-value {
    min-width: 0;
    display: flex;
    align-items: center;
}

.org-name-root {
    font-weight: 500;
    color: #303133;
}

.org-name-child {
    color: #606266;
}

.org-tree-tbl /deep/ .el-table__body .el-table__row .el-table__expand-icon {
    margin-left: 4px;
}

.level-tag {
    margin-right: 8px;
    padding: 2px 6px;
    font-size: 12px;
    border-radius: 3px;
}

.level-tag.level-1 {
    background-color: #ecf5ff;
    color: var(--btn-primary, #2563eb);
}

.level-tag.level-2 {
    background-color: #f0f9ff;
    color: #67c23a;
}

.pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
}

.event-form /deep/ .el-form-item__label {
    white-space: nowrap;
}

.dialog-footer {
    text-align: right;
}

.dialog-footer .el-button {
    min-width: 88px;
    padding: 10px 20px;
}

.ps-pick-summary .el-button--small {
    padding: 9px 15px;
}

.table-op-link {
    padding: 6px 10px !important;
    font-size: 13px !important;
}

/* 仅「编辑/删除」两字操作：按内容宽度，避免被操作列拉满。最后更新：2026-10-19 */
.event-list-table /deep/ .event-op-col .table-op-pair--compact,
.pg-table /deep/ .pg-op-col .table-op-pair--compact {
    display: inline-flex !important;
    grid-template-columns: none !important;
    width: auto !important;
    gap: 6px !important;
    justify-content: center !important;
}

.event-list-table /deep/ .event-op-col .table-op-pair--compact .table-op-link,
.pg-table /deep/ .pg-op-col .table-op-pair--compact .table-op-link {
    width: auto !important;
    min-width: 0 !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.event-list-toolbar .el-button--small {
    padding: 9px 15px;
}

.op-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px 12px;
}

.op-buttons .op-link {
    padding: 0 6px;
    margin: 0;
    min-width: auto;
    font-size: 13px;
}

.op-buttons .op-link-primary {
    color: var(--btn-primary, #2563eb);
}

.op-buttons .op-link-primary:hover {
    color: #66b1ff;
}

.op-buttons .op-link-info {
    color: #909399;
}

.op-buttons .op-link-info:hover {
    color: #a6a9ad;
}

.op-buttons .op-link-warning {
    color: #e6a23c;
}

.op-buttons .op-link-warning:hover {
    color: #ebb563;
}

.op-buttons .op-link-danger {
    color: #f56c6c;
}

.op-buttons .op-link-danger:hover {
    color: #f78989;
}

/* 成员数字按钮：去掉 hover 灰底/阴影，保持与普通文本链接一致 */
.org-tree-tbl /deep/ .member-count-btn.el-button--text {
    padding: 0;
    min-height: 20px;
    line-height: 20px;
    border: none;
    background: transparent;
}

.org-tree-tbl /deep/ .member-count-btn.el-button--text:hover,
.org-tree-tbl /deep/ .member-count-btn.el-button--text:focus,
.org-tree-tbl /deep/ .member-count-btn.el-button--text:active {
    background: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
}

/* 管理员列：tag 与表格文字垂直对齐，避免显得飘、对不齐 */
.admin-tags-inline {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
    vertical-align: middle;
    line-height: 1;
    max-width: 100%;
}

.admin-tags-inline .el-tag {
    margin: 0;
    height: 22px;
    line-height: 20px;
    padding: 0 7px;
    font-size: 12px;
    font-weight: 400;
    border-radius: 4px;
}

.admin-more-tag {
    cursor: help;
}

.admin-empty {
    color: #c0c4cc;
}

/* 管理员标签：每行显示两个（表单等场景） */
.admin-tags {
    display: flex;
    flex-wrap: wrap;
}

.admin-tags .el-tag {
    width: calc(50% - 8px);
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 6px;
    box-sizing: border-box;
}

/* 周次时段布局调整：每个周次一行，避免右侧被挤出视口 */
.week-day-box {
    width: 100%;
    padding: 6px 0;
    box-sizing: border-box;
}

.week-day-container {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
}

.weekday-label {
    color: #666;
}

.week-time {
    width: 180px;
    min-width: 140px;
}

/* 自定义导出遮罩已移除，统一走 exportLoadingMixin 的 $loading。最后更新：2026-11-02 */

.org-admin-hint,
.event-mgr-hint {
    color: #909399;
    font-size: 12px;
    line-height: 1.55;
    margin-bottom: 8px;
}

.org-admin-hint strong,
.event-mgr-hint strong {
    color: #606266;
}

.ps-pick-summary {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    color: #475569;
    font-size: 13px;
}

.ps-pick-tags {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.ps-pick-more {
    color: #94a3b8;
    font-size: 12px;
    line-height: 24px;
}

.muted-text {
    color: #94a3b8;
}

/* 总览权限弹窗。最后更新：2026-10-19 */
.overview-permission-body {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.overview-permission-footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    min-height: 40px;
}

.overview-unsaved-tip {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    color: #f56c6c;
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
    pointer-events: none;
}

.overview-permission-footer-actions {
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.overview-campus-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
}

.overview-campus-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #334155;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}

.overview-campus-label i {
    color: #2563eb;
}

.overview-campus-select {
    width: 260px;
}

.overview-rule-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.overview-rule-chip {
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 10px;
    border-radius: 999px;
    background: #eff6ff;
    color: #1d4ed8;
    font-size: 12px;
    font-weight: 600;
}

.overview-rule-text {
    color: #64748b;
    font-size: 12px;
    line-height: 1.5;
}

.overview-role-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.overview-role-card {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #fff;
    padding: 14px 16px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.overview-role-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.04);
}

.overview-role-card--view {
    border-left: 3px solid #3b82f6;
}

.overview-role-card--maintain {
    border-left: 3px solid #0ea5e9;
}

.overview-role-card--delete {
    border-left: 3px solid #22c55e;
}

.overview-role-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.overview-role-title-wrap {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    min-width: 0;
}

.overview-role-icon {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 16px;
}

.overview-role-icon--view {
    background: #eff6ff;
    color: #2563eb;
}

.overview-role-icon--maintain {
    background: #ecfeff;
    color: #0284c7;
}

.overview-role-icon--delete {
    background: #f0fdf4;
    color: #16a34a;
}

.overview-role-title {
    color: #0f172a;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
}

.overview-role-desc {
    margin-top: 2px;
    color: #64748b;
    font-size: 12px;
    line-height: 1.4;
}

.overview-role-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.overview-role-count {
    color: #64748b;
    font-size: 12px;
    white-space: nowrap;
}

.overview-role-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}

.overview-role-empty {
    margin-top: 12px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #f8fafc;
    color: #94a3b8;
    font-size: 12px;
}

/* 专业组维护弹窗：固定高度，表格区占满剩余空间。最后更新：2026-10-19 */
.professional-group-dialog /deep/ .el-dialog {
    margin-top: 10vh !important;
    height: 72vh;
    max-height: 720px;
    display: flex;
    flex-direction: column;
}

.professional-group-dialog /deep/ .el-dialog__header,
.professional-group-dialog /deep/ .el-dialog__footer {
    flex-shrink: 0;
}

.professional-group-dialog /deep/ .el-dialog__body {
    flex: 1;
    min-height: 0;
    padding: 12px 20px 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.pg-dialog-inner {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.pg-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
    flex-shrink: 0;
}

.pg-toolbar-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.pg-table-wrap {
    /* height:0 + flex:1 让表格区吃满弹窗剩余高度，供 el-table height=100% 正确计算 */
    flex: 1;
    height: 0;
    min-height: 360px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
}

.pg-table /deep/ .el-table__header th {
    background: #f7f9fc;
    color: #606266;
}

.pg-pagination {
    margin-top: 12px;
    text-align: right;
    flex-shrink: 0;
}

.pg-pagination /deep/ .el-pagination {
    display: inline-flex;
    justify-content: flex-end;
}

/* 活动事件列表弹窗：对齐专业组维护弹窗布局。最后更新：2026-10-20 */
.event-list-dialog /deep/ .el-dialog {
    width: 90% !important;
    max-width: 1280px;
    margin-top: 8vh !important;
    margin-bottom: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
    height: 80vh;
    max-height: 860px;
    display: flex;
    flex-direction: column;
}

.event-list-dialog /deep/ .el-dialog__header,
.event-list-dialog /deep/ .el-dialog__footer {
    flex-shrink: 0;
}

.event-list-dialog /deep/ .el-dialog__body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
    padding: 12px 20px 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.event-dialog-inner {
    flex: 1;
    height: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.event-list-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    flex-wrap: wrap;
    gap: 4px 0;
    margin-bottom: 12px;
}

.event-table-wrap {
    /* height:0 + flex:1 吃满中间；表格用数字 height 铺满，躲开全站 420 限制 */
    flex: 1;
    height: 0;
    min-height: 0;
    width: 100%;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
}

/* 覆盖 dialog-theme 中弹窗表格 body max-height:420px */
.event-list-dialog /deep/ .event-list-table .el-table__body-wrapper,
.event-list-dialog /deep/ .event-list-table .el-table__fixed-body-wrapper {
    max-height: none !important;
}

.event-pagination-in-dialog {
    flex-shrink: 0;
}

.event-list-table {
    width: 100% !important;
}

/* 管理员等列多个标签时换行，避免为压横滑而挤压单标签成“全…” */
.event-list-table /deep/ .admin-tags-inline {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px;
    line-height: 1.4;
}

.event-list-table /deep/ .el-table__header th {
    background: #f7f9fc;
    color: #606266;
}

/* 合并列：表头与内容统一左对齐。最后更新：2026-10-28 */
.event-list-table /deep/ .event-merge-left-col > .cell {
    text-align: left !important;
}

.event-list-table /deep/ .cell {
    line-height: 20px;
}

.event-list-table /deep/ td {
    padding: 7px 0;
}

.event-list-table /deep/ .event-op-col .cell {
    overflow: visible;
    padding-left: 4px;
    padding-right: 4px;
}

.student-event-query-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
}

.student-event-query-dialog /deep/ .el-dialog {
    width: 1080px !important;
    max-width: 96vw;
}

.student-event-student-pick {
    min-width: 280px;
}

.student-event-table-wrap /deep/ .student-event-detail-btn {
    padding: 0;
    transition: none !important;
    animation: none !important;
}

.student-event-table-wrap /deep/ .student-event-detail-btn,
.student-event-table-wrap /deep/ .student-event-detail-btn:hover,
.student-event-table-wrap /deep/ .student-event-detail-btn:focus,
.student-event-table-wrap /deep/ .student-event-detail-btn:active {
    background-color: transparent !important;
    border-color: transparent !important;
    box-shadow: none !important;
    outline: none;
}

.student-event-query-hint {
    margin: 8px 0 0;
    font-size: 12px;
    color: #909399;
}

.student-event-detail-body {
    max-height: 65vh;
    overflow-y: auto;
}

.student-event-detail-sessions {
    margin-top: 16px;
}

.student-event-detail-sessions-title {
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}

.student-event-session-count {
    margin-left: 4px;
    font-size: 12px;
    font-weight: normal;
    color: #909399;
}

.student-event-session-count-inline {
    margin-bottom: 8px;
    font-size: 12px;
    color: #909399;
}

.student-event-session-pagination {
    margin-top: 10px;
    text-align: right;
}

.student-event-detail-fallback {
    padding: 12px;
    font-size: 13px;
    color: #606266;
    background: #fafafa;
    border-radius: 4px;
}

/* 活动弹窗内分页：紧贴表格。最后更新：2026-10-20 */
.event-list-dialog .event-pagination-in-dialog.pagination-container {
    width: 100%;
    margin-top: 8px;
    margin-bottom: 0;
    text-align: right;
}

.event-pagination-in-dialog /deep/ .el-pagination {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    float: none;
    margin-left: 0;
}

@media (max-width: 1366px) {
    .event-list-dialog /deep/ .el-dialog {
        width: 96% !important;
        max-width: 1180px;
    }
}

@media (max-width: 600px) {
    .event-list-dialog /deep/ .el-dialog {
        width: 98% !important;
        max-width: 100%;
    }
}

/* 组织管理列表管理员查看按钮与弹窗。最后更新：2026-09-08 */
.kq-dept-link-btn {
    padding: 4px 10px;
    font-size: 13px;
    color: #2563eb;
    background-color: #eff6ff;
    border-radius: 4px;
    line-height: 18px;
    border: 1px solid #bfdbfe;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.2s;
}

.kq-dept-link-btn:hover,
.kq-dept-link-btn:focus {
    color: #1d4ed8;
    background-color: #dbeafe;
    border-color: #93c5fd;
}

.kq-dept-view-dialog .el-dialog__body {
    padding: 16px 20px 10px;
}

.kq-view-head {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 10px 16px;
    margin-bottom: 14px;
}

.kq-view-head-item {
    font-size: 13px;
    color: #334155;
}

.kq-view-head-item .label {
    color: #64748b;
}

.kq-view-head-item .val {
    font-weight: 500;
    color: #0f172a;
}

.kq-view-head-item .count-badge {
    display: inline-block;
    padding: 1px 8px;
    border-radius: 12px;
    font-size: 12px;
    background-color: #eff6ff;
    color: #2563eb;
    font-weight: 600;
}

.kq-view-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.kq-view-search-input {
    max-width: 280px;
}

.kq-view-table-wrap {
    border-radius: 4px;
    overflow: hidden;
}

.kq-view-pager {
    margin-top: 10px;
    text-align: right;
}

.kq-view-pager /deep/ .el-pagination {
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.kq-view-table .dept-text {
    font-size: 13px;
    color: #1e293b;
    font-weight: 500;
}

.kq-view-empty {
    padding: 30px 0;
    color: #94a3b8;
    font-size: 13px;
}
</style>
